import { faCircleCheck, faEye } from '@fortawesome/free-regular-svg-icons';
import { faCircleInfo, faCircleXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import CancelDialog from '../CancelDialog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import Dialog_IRN from '../Dialog_IRN';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Master_individual_profile from '../master/Master_individual_profile';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import Tran_date_change_modal from './Tran_date_change_modal';
import Tran_passport_form from './Tran_passport_form';
import Tran_stock_modal from './Tran_stock_modal';

function Tran_sp() {
    const productRef = useRef();
    const [radioType, setRadioType] = useState("N");
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const [key, setKey] = useState("INFO");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [scrMode, setScrMode] = useState("");
    const [userRight, setUserRight] = useState([]);
    const [residentOptions, setResidentOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);

    const [hdrSrno, setHdrSrno] = useState(0);
    const [spList, setSPList] = useState([]);

    const [spLocation, setSPLocation] = useState(null);
    const [spLocationValue, setSPLocationValue] = useState("");
    const [spFromDate, setSPFromDate] = useState(new Date());
    const [spToDate, setSPToDate] = useState(new Date());
    const [spIndividual, setSPIndividual] = useState(null);
    const [spSrnoFrom, setSPSrnoFrom] = useState("");
    const [spSrnoTo, setSPSrnoTo] = useState("");
    const [spNewDate, setSPNewDate] = useState(new Date());
    const [spStateName, setSPStateName] = useState("");
    const [spStateValue, setSPStateValue] = useState("");
    const [spStateType, setSPStateType] = useState("");
    const [spSaleType, setSPSaleType] = useState("N");
    const [spProductList, setSPProductList] = useState([]);

    const [nExecutive, setNExecutive] = useState(null);
    const [nSubExecutive, setNSubExecutive] = useState(null);

    const [nTraveller, setNTraveller] = useState(null);
    const [nPurpose, setNPurpose] = useState(null);
    const [nPurposeId, setNPurposeId] = useState("0");
    const [nResident, setNResident] = useState(1);
    const [nTravellerCode, setNTravellerCode] = useState("");
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [nCorporate, setNCorporate] = useState(null);
    const [nCountry, setNCountry] = useState(null);
    const [nDepDate, setNDepDate] = useState(null);
    const [nTicketNo, setNTicketNo] = useState("");
    const [nFlightNo, setNFlightNo] = useState("");
    const [nDuration, setNDuration] = useState("");
    const [nVisaType, setNVisaType] = useState(null);
    const [nTicketClass, setNTicketClass] = useState("");
    const [nPanForm60, setNPanForm60] = useState("P");
    const [nMode, setNMode] = useState("B");

    const [pIssuerGroup, setPIssuerGroup] = useState("");
    const [pIssuerAccount, setPIssuerAccount] = useState("");
    const [pIssuer, setPIssuer] = useState(null);
    const [pIsd, setPIsd] = useState(null);
    const [pIsdId, setPIsdId] = useState(0);
    const [pDenomination, setPDenomination] = useState("");
    const [pQuantity, setPQuantity] = useState("");
    const [pRate, setPRate] = useState("");
    const [pProduct, setPProduct] = useState("CN");
    const [prPrefix, setPrPrefix] = useState("");
    const [prFrom, setPrFrom] = useState(null);
    const [prFromValue, setPrFromValue] = useState("");
    const [prTo, setPrTo] = useState("");
    const [pVtmCardNo, setPVtmCardNo] = useState("");
    const [isCommission, setIsCommission] = useState("0");
    const [pAgent, setPAgent] = useState(null);
    const [commType, setCommType] = useState("F");
    const [commValue, setCommValue] = useState("");
    const [maxPRate, setMaxPRate] = useState(0);
    const [minPRate, setMinPRate] = useState(0);

    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);
    const [pSaleReload, setPSaleReload] = useState("S");
    const [disableOtherCharge, setDisableOtherCharge] = useState(true);
    const [nServiceType, setNServiceType] = useState("");

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [chequeBankName, setChequeBankName] = useState("");
    const [chequeDate, setChequeDate] = useState(null);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [paymentLineNo, setPaymentLineNo] = useState(0);
    const [showMinMaxRateModal, setShowMinMaxRateModal] = useState(false);
    const [minMaxRate, setMinMaxRate] = useState([]);

    const [counter, setCounter] = useState(0);
    const [productLineNo, setProductLineNo] = useState(1);

    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [nTravellerSrno, setNTravellerSrno] = useState("");
    const [scrIndividual, setScrIndividual] = useState("");

    const [commission, setCommission] = useState("");
    const [hdrDate, setHdrDate] = useState(null);
    const [hdrLocation, setHdrLocation] = useState("");

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [usdRate, setUSDRate] = useState(0);
    const [travellerSelected, setTravellerSelected] = useState(0);
    const [showPreviousTransactionModal, setShowPreviousTransactionModal] = useState(false);
    const [preTransaction, setPreTransaction] = useState([]);
    const [showLRSTransactionModal, setShowLRSTransactionModal] = useState(false);
    const [lrsTransaction, setLrsTransaction] = useState([]);

    const [travellerPan, setTravellerPan] = useState("");
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);

    const [isMsgBoxCreditLimit, setMsgBoxCreditLimit] = useState(false);
    const [msgTextCreditLimit, setMsgTextCreditLimit] = useState("");
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [filterProduct, setFilterProduct] = useState("C");

    const [showCommissionDetail, setShowCommissionDetail] = useState(false);
    const [isMsgBoxCancelBill, setMsgBoxCancelBill] = useState(false);
    const [msgTextCancelBill, setMsgTextCancelBill] = useState("");

    const [isIrnGenerated, setIsIrnGenerated] = useState("0");
    const [irnObj, setIrnObj] = useState({ irn: "", ackdate: "", acknum: "", signedqr: "" });
    const [isIrnCancelled, setIsIrnCancelled] = useState("0");
    const [irnCancelDate, setIrnCancelDate] = useState("");
    const [irnCancelReason, setIrnCancelReason] = useState("");
    const [irnCancelLabel, setIrnCancelLabel] = useState("");
    const [irnCancelDeclaration, setIrnCancelDeclaration] = useState(false);

    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [isIrnApplicable, setIsIrnApplicable] = useState("N");
    const [corpServiceCharge, setCorpServiceCharge] = useState(0);

    const [irnCancelReasonHdr, setIrnCancelReasonHdr] = useState("");
    const [irnCancelReasonSelect, setIrnCancelReasonSelect] = useState("");
    const [irnCancelRemarkHdr, setIrnCancelRemarkHdr] = useState("");
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [pdRemark, setPdRemark] = useState("");
    const [sourceOfFund, setSourceOfFund] = useState(null);
    const [sourceOfFundOther, setSourceOfFundOther] = useState("");
    const [sourceOfFundValue, setSourceOfFundValue] = useState("")
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [compareData, setCompareData] = useState([]);

    const [dsrRate, setDsrRate] = useState("");
    const [pTcs, setPTcs] = useState("");

    const [reqLoanAvailed, setReqLoanAvailed] = useState("0");
    const [reqLoanAccountNo, setReqLoanAccountNo] = useState("");
    const [reqLoanApplicant, setReqLoanApplicant] = useState("");
    const [reqLoanApplicantPassport, setReqLoanApplicantPassport] = useState("");
    const [reqLoanApplicantPan, setReqLoanApplicantPan] = useState("");
    const [reqLoanCoApplicant, setReqLoanCoApplicant] = useState("");
    const [reqLoanCoApplicantPassport, setReqLoanCoApplicantPassport] = useState("");
    const [reqLoanCoApplicantPan, setReqLoanCoApplicantPan] = useState("");

    const [reqLoanInstName, setReqLoanInstName] = useState("");
    const [reqLoanDisbAmt, setReqLoanDisbAmt] = useState("");
    const [reqLoanDisbDate, setReqLoanDisbDate] = useState(null);
    const [reqLoanDisbRefNo, setReqLoanDisbRefNo] = useState("");

    const [travellerCnt, setTravellerCnt] = useState("0");
    const [vtcIsd, setVtcIsd] = useState("0");
    const [panRelationship, setPanRelationship] = useState(null);
    const [panRelationShipCode, setPanRelationshipCode] = useState("");
    const [pan, setPan] = useState("");
    const [panName, setPanName] = useState("");
    const [nPurposeIsLoan, setNPurposeIsLoan] = useState("");
    const [sourceOfFundId, setSourceOfFundId] = useState("");
    const [nDob, setNDob] = useState(null);
    const [nManualno, setNManualno] = useState(null);

    const [openDateChangeModal, setOpenDateChangeModal] = useState(false);
    const [changeDateObj, setChangeDateObj] = useState({});

    const [a2FormRight, setA2FormRight] = useState([]);

    const [showStockModal, setShowStockModal] = useState(false);
    const [stockObj, setStockObj] = useState({});
    const [dateChangeRight, setDateChangeRight] = useState();


    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");

    const [isMsgBoxYNvtm, setMsgBoxYNvtm] = useState(false);
    const [msgTextYNvtm, setMsgTextYNvtm] = useState("");
    const [pTcsRate, setPTcsRate] = useState(0);
    const [acRemark, setAcRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [riskValue, setRiskValue] = useState("0");
    const [riskModalBoxText, setRiskModalBoxText] = useState("");
    const [showPassForm, setShowPassForm] = useState(false);
    const [createIndivisualByPassport, setCreateIndivisualByPassport] = useState(null);

    const [pTcsTaxable, setPTcsTaxable] = useState(0);
    const [pSelfDeclaration, setPSelfDeclaration] = useState(0);
    const [cancelButtonView, setCancelButtonView] = useState(true);
    const [empType, setEmpType] = useState('E');
    const [cntIssue, setCntIssue] = useState(0);
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
    const [isAirport, setIsAirport] = useState("0");
    const [otherChargesInputVisibility, setOtherChargesInputVisibility] = useState(false)
    const [pExclusiveGst, setPExclusiveGst] = useState(0);

    const [individualName, setIndividualName] = useState("");
    const [individualPan, setIndividualPan] = useState("");
    const [individualAddress, setIndividualAddress] = useState("");

    const [corporateName, setCorporateName] = useState("");
    const [corporatePan, setCorporatePan] = useState("");
    const [corporateAddress, setCorporateAddress] = useState("");
    const [corporateGstin, setCorporateGstin] = useState("");

    const [agentName, setAgentName] = useState("");
    const [agentAddress, setAgentAddress] = useState("");
    const [agentPan, setAgentPan] = useState("");
    const [corpName, setCorpName] = useState("");
    const [pdCommisionOnOtherCharges, setPdCommisionOnOtherCharges] = useState("0");
    const [pdAgent, setPdAgent] = useState(null);
    const [agentGroup, setAgentGroup] = useState(0);
    const [agentAccount, setAgentAccount] = useState(0);
    const [pdCommission, setPdCommission] = useState(0);

    const [nEncashmentNumber, setNEncashmentNumber] = useState("");
    const [nEncashmentDate, setNEncashmentDate] = useState(null);
    const [nEncashmentFrom, setNEncashmentFrom] = useState("");
    const [individualId, setIndividualId] = useState("");
    const [individualNumber, setIndividualNumber] = useState("");
    const [confirmResolve, setConfirmResolve] = useState(null);
    const [irnPauseRight, setIRNPauseRight] = useState(null);
    const [checkIsirn, setIsirn] = useState(null);
    const [hdrTranSource, setHdrTranSource] = useState("");

    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setSPLocation(response);
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_SP'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserCancelBillRight(resp);
            }
        });
        // A2 Form Right ===========================
        Common.callApi(Common.apiRight, [sid, 'all', 'A2_FORM'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setA2FormRight(resp);
            }
        });
        Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
            setResidentOptions(JSON.parse(result));
        });
        //get CREATE_INDIVIDUAL_BY_PASPPORT ===========================
        Common.callApi(Common.apiRight, [sid, 'all', 'CREATE_INDIVIDUAL_BY_PASPPORT'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setCreateIndivisualByPassport(resp);
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'IRN_PAUSE'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setIRNPauseRight(resp);
            }
        });

        const sessionValues = sessionStorage.getItem('values');
        if (sessionValues) {
            const sessionData = JSON.parse(sessionValues);
            if (sessionData.md_type == 'SALE') {
                setScrMode('A');
                Common.callApi(Common.apiIndividualProfile, [sid, 'getIndividualData', sessionData.code], (result) => {
                    let resp = JSON.parse(result);
                    console.log("RESPONSE IS  ", resp);
                    handleTravellerChange({ ...resp, desc: `${resp.desc.replaceAll('^', '  ^  ')}` })
                    // setNTraveller(resp);
                });
                sessionStorage.removeItem('values');
            } else {
                setScrMode('');
            }
        }
        Common.getDateChangeRight(sid, setDateChangeRight);//get right to change date

    }, []);

    const handleLocationChange = (value) => {
        setSPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setSPLocationValue(location[1]);
        setSPStateValue(location[3] == null ? 0 : location[3]);
        setSPStateType(location[4]);
        setSPStateName(location[5] === "" ? "Select" : location[5]);

        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        setIsAirport(location[10]);
        sessionStorage.activeBranch = location[1];
        if (location[3] * 1 > 0 && location[3] != null) setNState({ value: location[3], label: location[5] });
        else setNState({ value: 0, label: "Select" });
    }

    const handleIndiviualChange = (value) => {
        console.log("value", value);
        setSPIndividual(value);
    }

    const listSPdata = () => {
        var msg = [], i = 0;
        $(".loader").show();
        if (spLocation === null || (radioType === 'S' && !spSrnoFrom) || (radioType === 'S' && !spSrnoTo) || (radioType === 'D' && !spFromDate) || (radioType === 'D' && !spToDate) || (radioType === 'I' && spIndividual === null) || (radioType === 'I' && !spFromDate) || (radioType === 'I' && !spToDate) || (radioType === 'C' && nCorporate === null) || (radioType === 'C' && !spFromDate) || (radioType === 'C' && !spToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (spLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !spSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !spSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !spFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !spToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && spIndividual === null ? " Individual." : '');
            msg[i++] = (radioType === 'I' && !spFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'I' && !spToDate ? " To Date." : '');
            msg[i++] = (radioType === 'C' && nCorporate === null ? " Corporate." : '');
            msg[i++] = (radioType === 'C' && !spFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'C' && !spToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                type: "SP",
                radioType: radioType,
                spLocation: spLocationValue,
                //ppCorporate: ppCorporate,
                spIndividual: spIndividual,
                spNewDate: Common.dateYMD(spNewDate),
                spSrnoTo: spSrnoTo,
                spSrnoFrom: spSrnoFrom,
                spFromDate: Common.dateYMD(spFromDate),
                spToDate: Common.dateYMD(spToDate)
            }
            Common.callApi(Common.apiTranSP, [sid, "splist", JSON.stringify(obj)], result => {
                console.log(result);
                $(".loader").hide();
                setSPList(JSON.parse(result));
            });
        }
    }

    const addNewForm = () => {
        var d = Common.dateYMD(spNewDate);
        var ddmy = Common.dateDMY(spNewDate);
        var today = Common.dateYMD(new Date());
        if (spLocation == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                addNewFormResetFields(ddmy);
            } else {
                const obj = {
                    billdate: d,
                    location: spLocationValue,
                    type: "SP"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        addNewFormResetFields(ddmy);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = (ddmy) => {
        setHdrDate(ddmy);

        setScrMode('A');
        setKey('INFO');
        setProductLineNo(1);
        setHdrSrno(0);
        setNExecutive(null);
        setNSubExecutive(null);
        setNMode("B");
        setNTraveller(null);
        setNPurpose(null);
        setNResident(1);
        setNTravellerCode("");
        setNCorporate(null);
        if (spStateValue * 1 > 0 && spStateValue != null) setNState({ value: spStateValue, label: spStateName });
        else setNState({ value: 0, label: "Select" });
        setNPanForm60("P");
        setNCountry(null);
        setNTicketClass("");
        setNTicketNo("");
        setNFlightNo("");
        setNDepDate(null);
        setNDuration("");
        setNVisaType("");
        setPForexTotal(0);
        setPTotalAmount(0);
        setPCgst(0);
        setPIgst(0);
        setPUgst(0);
        setPSgst(0);
        setPRoundOff(0);
        setPOtherCharges(0);
        setSPProductList([]);
        setPaymentData([]);
        setTravellerSelected(0);
        setCorpServiceCharge(0);
        setPTaxableVal(0);
        setSourceOfFund(null);
        setSourceOfFundOther('');
        setPdRemark("");
        setNRemark1("");
        setNRemark2("");

        setReqLoanAvailed("0");
        setReqLoanAccountNo("");
        setReqLoanApplicant("");
        setReqLoanApplicantPassport("");
        setReqLoanApplicantPan("");
        setReqLoanCoApplicant("");
        setReqLoanCoApplicantPassport("");
        setReqLoanCoApplicantPan("");
        setReqLoanDisbRefNo("");
        setReqLoanDisbDate(null);
        setReqLoanDisbAmt("");
        setReqLoanInstName("");

        setTravellerPan("");
        setTravellerCnt("0");
        setNPurposeId("0");
        setVtcIsd("0");

        setPProduct("CN");
        setPSaleReload("S");
        setPIsd(null);
        setPIssuer(null);
        setPDenomination("");
        setPRate("");
        setPrPrefix("");
        setPrFrom(null);
        setPrTo("");
        setPVtmCardNo("");
        setIsCommission("0");
        setPQuantity("");
        setSourceOfFundValue("");
        setNPurposeIsLoan("0");
        setNDob(null);
        setPanRelationship(null);
        setPanRelationshipCode("");
        setPan("");
        setPanName("");
        setNManualno(null);
        setPTcsRate(0);
        setPTcs(0);
        setRiskValue("0");
        setAcRemark("");
        setPTcsTaxable(0);
        setPSelfDeclaration(0);
        setEmpType('E');
        setPAgent(null);
        setCommType("F");
        setCommission("");
        setCommValue("");
        setIndividualName("");
        setIndividualPan("");
        setIndividualAddress("");

        setCorporateName("");
        setCorporateAddress("");
        setCorporateGstin("");
        setCorporatePan("");
        setPdCommisionOnOtherCharges("0");
        setPdAgent(null);
        setPdCommission(0);
        setNEncashmentNumber("");
        setNEncashmentFrom("");
        setNEncashmentDate(null);

        Common.callApi(Common.apiState, [sid, "getState", 1], result => {
            setStateOptions(JSON.parse(result));
        });
    }


    const fillViewCompareObject = (resp) => {
        const obj2 = {
            nExecutive: resp.executive == null ? null : { id: resp.executive, label: resp.executive_name },
            nSubExecutive: (resp.sub_executive == null || resp.sub_executive == '0') ? null : { id: resp.sub_executiveid, label: resp.sub_executivelabel },
            nMode: resp.mode,
            nTraveller: { id: resp.ind_id, label: resp.ind_label, desc: resp.desc },
            nPurpose: { id: resp.purpose, label: resp.purpose_name },
            nResident: resp.residential,
            nTravellerCode: resp.emp_code,
            nCorporate: resp.corp_id === null ? null : { id: resp.corp_id, label: resp.corp_label },
            nState: resp.state,
            sourceOfFund: { id: resp.sourceoffundCode, label: resp.sourceoffund },
            nCountry: { id: resp.cntsrno, label: resp.cntname },
            nTicketClass: resp.ticketclass,
            nFlightNo: resp.flightno,
            nTicketNo: resp.ticketno,
            nDepDate: Common.dateYMD(nDepDate),
            nDuration: resp.duration,
            nVisaType: resp.visatype,
            nRemark1: resp.remark1,
            nRemark2: resp.remark2,
        };
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, date) => {
        setHdrSrno(hdrsrno);
        setKey('INFO');
        setPrFrom(null);
        setPrFromValue("");
        //setRandomString("0");
        $(".loader").show();
        const obj = {
            srno: hdrsrno,
            spLocationValue: spLocationValue,
            type: "SP"
        }
        Common.callApi(Common.apiTranSP, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                fillViewCompareObject(resp);
                $(".loader").hide();
                setScrMode("Q");
                setSPSaleType(resp.saletype);
                setViewDate(resp.date);
                setNTraveller({ id: resp.ind_id, label: resp.ind_label, desc: resp.desc });
                setNTravellerSrno(resp.individual_srno);
                if (resp.executive == null) setNExecutive(null);
                else setNExecutive({ id: resp.executive, label: resp.executive_name });
                if (resp.sub_executive == null || resp.sub_executive == "0") setNSubExecutive(null);
                else setNSubExecutive({ id: resp.sub_executiveid, label: resp.sub_executivelabel });
                setNMode(resp.mode);
                setNPurpose({ id: resp.purpose, label: resp.purpose_name });
                setNPurposeId(resp?.purpose?.split("^")[1]);
                setNServiceType(resp.service_type);
                setNCountry({ id: resp.cntsrno, label: resp.cntname });
                setNResident(String(resp.residential));
                setHdrTranSource(resp.hdr_tran_source);
                if (resp.corp_id == null) {
                    setNCorporate(null);
                    setCorpServiceCharge(0);
                } else {
                    setNCorporate({ id: resp.corp_id, label: resp.corp_label });
                    setCorpServiceCharge(resp.corp_id.split("^")[8]);
                }
                setNTravellerCode(resp.emp_code);
                setNState({ value: resp.state, label: resp.statename });
                setNPanForm60(resp.panform60);
                setNTicketClass(resp.ticketclass);
                setNFlightNo(resp.flightno);
                setNTicketNo(resp.ticketno);
                setNDepDate(new Date(resp.depdate));
                setNDuration(resp.duration)
                setNVisaType(resp.visatype);
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);

                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);

                setSPProductList(resp.productlist);
                setPaymentData(resp.paydetails);
                setPaymentLineNo(resp.paymaxlineno);
                setProductLineNo(resp.maxlineno);

                setHdrDate(resp.date);
                setHdrLocation(resp.locname);
                setHdrSrno(resp.srno);
                setTravellerSelected(0);
                setTravellerPan(resp.ind_pan);

                setHdrDateYmd(resp.dateymd);
                setIsIrnApplicable(resp.is_irn_applicable);

                setIsIrnGenerated(resp.isIrnGenerated);
                setIsIrnCancelled(resp.isIrnCancelled);
                setIrnCancelDate(resp.irncanceldt);
                setIrnCancelRemarkHdr(resp.irncancelrmk);
                setSourceOfFund({ id: resp.sourceoffundCode, label: resp.sourceoffund });
                setPanRelationship({ id: resp.panrelationid, label: resp.panrelationlabel });
                setPanRelationshipCode(resp.panrelationid.split("^")[1])
                setPan(resp.pan);
                setPanName(resp.panname);
                setNVisaType({ id: resp.visatypeCode, label: resp.visatype });

                setReqLoanAvailed(resp.isloanavailed);
                setReqLoanAccountNo(resp.loanAccountNo);
                setReqLoanApplicant(resp.loanApplicant);
                setReqLoanApplicantPassport(resp.loanApplicantPassport);
                setReqLoanApplicantPan(resp.loanApplicantPan);
                setReqLoanCoApplicant(resp.loanCoApplicant);
                setReqLoanCoApplicantPassport(resp.loanCoApplicantPassport);
                setReqLoanCoApplicantPan(resp.loanCoApplicantPan);
                setReqLoanDisbRefNo(resp.loanDisbRefno);
                if (resp.loanDisbDate == null) setReqLoanDisbDate(null);
                else setReqLoanDisbDate(new Date(resp.loanDisbDate));
                setReqLoanDisbAmt(resp.loanDisbAmt);
                setReqLoanInstName(resp.loanInstName);
                setNDob(new Date(resp.dob));

                setTravellerCnt(resp.individual_cnt);
                setPTcs(resp.tcsamt);
                setPTcsRate(resp.tcsrate);
                setPTcsTaxable(resp.tcstaxable);
                setPSelfDeclaration(resp.selfdeclaration);
                setCancelButtonView(+resp.hdr_cancel_billYN === 1 ? false : true);
                //setSPNewDate(new Date(resp.dateymd))
                if (resp.manualid == null) setNManualno(null);
                else setNManualno({ id: resp.manualid, label: resp.manuallabel });
                setEmpType(resp.emp_type);
                setSourceOfFundValue(resp.sourceoffundCode.split('^')[2]);
                setSourceOfFundOther(resp.sourceOfFundOther);
                setIndividualName(resp.ind_id.split('^')[3]);
                setIndividualPan(resp.ind_id.split("^")[4]);
                setIndividualAddress(resp.ind_id.split("^")[9]);

                setPdCommisionOnOtherCharges(resp.hdr_oth_commission_yes_no);
                setPdAgent({ id: resp.oth_agent_id, label: resp.oth_agent_label });
                setPdCommission(resp.hdr_oth_commission_bank_charges);
                setAgentGroup(resp.hdr_oth_commission_agent_group);
                setAgentAccount(resp.hdr_oth_commission_agent_account);
                setNEncashmentNumber(resp.hdr_encashment_no);
                setNEncashmentFrom(resp.hdr_encashed_by);
                if (resp.hdr_encashment_date == null) setNEncashmentDate(null);
                else setNEncashmentDate(new Date(resp.hdr_encashment_date));
                if (+resp.isIrnGenerated === 1) {
                    setIrnObj({
                        irn: resp.irn,
                        ackdate: resp.ackdate,
                        acknum: resp.ackno,
                        signedqr: resp.signedqr
                    });
                }
                if (!(resp.irncancelreason == null || resp.irncancelreason == "")) {
                    setIrnCancelReasonHdr(Common.getIrnCancelReason.find(item => item.id == resp.irncancelreason).desc);
                }
                setIndividualName(resp.individualName);
                setIndividualAddress(resp.individualAddress);
                setCorporateName(resp.ledgerName);
                setCorporateAddress(resp.ledgerAddress);
                setIndividualId(resp.individualIdName);
                setIndividualNumber(resp.individualNumber);
                isCommissionAdded(resp.productlist);
                setIsirn(resp.hdr_isirn);
            }
        });
    }
    function isCommissionAdded(productList) {
        let isCommission = "0";
        productList.map((product) => {
            if (+product.iscommission === 1) {
                isCommission = product.iscommission;
                return;
            }
        })
        console.log(isCommission);
        setIsCommission(isCommission);
    }

    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }
    const handleSubExecutiveChange = (value) => {
        setNSubExecutive(value);
    }

    const handleTravellerChange = (value) => {
        console.log("Ind is :", value);
        setNTraveller(value);
        var a = value.id.split("^");
        setNTravellerSrno(a[1]);
        setTravellerSelected(1);
        setTravellerPan(a[4]);
        setTravellerCnt(a[5]);
        setCntIssue(a[8]);
        setIndividualName(a[3]);
        setIndividualPan(a[4]);
        setIndividualAddress(a[9]);
        setIndividualId(a[10]);
        setIndividualNumber(a[11]);
        console.log("Country Issue is :", a[8]);
        if (nCorporate === null) {
            setPanRelationship({ id: "^1^SELF", label: "1 SELF" });
            setPanRelationshipCode('1')
            setPan(a[4]);
            setPanName(a[3]);
            setNDob(new Date(a[6]));
        }
    }

    const handlePurposeChange = (value) => {
        setNPurpose(value);
        var p = value.id.split("^");
        setNPurposeId(p[1]);
        setNPurposeIsLoan(p[3]);
        setReqLoanAvailed("0");
        if (+p[3] === 1 && sourceOfFundValue === "LOAN") {
            setReqLoanAvailed("1");
        }
        if (spProductList.length > 0) {
            const obj = {
                tranType: "SP",
                type: "SALE",
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                ppStateType: spStateType,
                ppStateValue: spStateValue,
                nState: nState.value,
                nCorporate: nCorporate,
                travellerPan: pan,
                loan: +reqLoanAvailed === 1 ? "Y" : "N",
                purpose: p[1],
                pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,

                srno: hdrSrno,
                spLocationValue: spLocationValue,
            }
            calculateGST(spProductList, obj);
        }
    }
    const handleSourceFundChange = (value) => {
        setSourceOfFund(value);
        const a = value.id.split("^");
        setSourceOfFundValue(a[2]);
        setReqLoanAvailed("0");
        if (+nPurposeIsLoan === 1 && a[2] === "LOAN") {
            setReqLoanAvailed("1");
        }
        setSourceOfFundId(a[1]);
    }
    const handleVisaTypeChange = (value) => {
        setNVisaType(value);
    }

    const handleCorporateChange = (value) => {
        // if(spProductList.length >0){
        //     alert("Remove the products for Corporate Change");
        // }else{
        // Here comes below complete code 
        // }
        setNCorporate(value);
        var id = value.id;
        var corp = id.split("^");
        if (isAirport != "1") {
            setNState({ value: corp[3], label: corp[4] });
        }
        setCorporateName(corp[11]);
        setCorporatePan(corp[12]);
        setCorporateAddress(corp[15]);
        setCorporateGstin(corp[9]);
        otherChargeChange(corp[8], value);
        setCorpServiceCharge(corp[8] == "" ? 0 : corp[8]);
        setPdPaymentType("");
        setPdAccount(null);
        setPanRelationship({ id: "^1^SELF", label: "1 SELF" });
        setPanRelationshipCode('1')
        setPan(corp[12]);
        setPanName(corp[11]);
        if (corp[13] === "") {
            setNDob(null);
        } else {
            setNDob(new Date(corp[13]))
        }
        if (spProductList.length > 0) {
            const obj = {
                tranType: "SP",
                type: "SALE",
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                ppStateType: spStateType,
                ppStateValue: spStateValue,
                nState: isAirport != "1" ? corp[3] : nState,
                nCorporate: value,
                travellerPan: corp[12],
                loan: +reqLoanAvailed === 1 ? "Y" : "N",
                purpose: nPurposeId,
                pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,
                srno: hdrSrno,
                spLocationValue: spLocationValue,
            }
            calculateGST(spProductList, obj);
        }
    }

    const handleCountryChange = (value) => {
        setNCountry(value);
    }

    const handleTabChange = (k) => {
        setKey(k);
        if (k === "PAYMENT") {
            setPdAccount(null);
            setPdPaymentType("");
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    // const cancelData = () => {
    //     setMsgBoxYN(false);
    //     setScrMode("");
    // }

    const cancelData = () => {
        setMsgBoxYN(false);
        const sessionData = JSON.parse(sessionStorage.getItem('values'));
        if (sessionData && sessionData.md_type === "SALE") {
            sessionStorage.removeItem('values');
            sessionStorage.setItem('flag', '1');
            navigate('/individual-profile');
        } else {
            setScrMode("");
        }
    }

    const handleProductChange = (v) => {
        setPProduct(v);
        setPIsd(null);
        setSPSaleType("N");
        setPIssuer(null);
        setPDenomination("");
        if (v === "VTM") setPQuantity(1);
        else setPQuantity("");
        setPRate("");
        setPrFrom(null);
        setPrFromValue("");
        setPrPrefix("");
        setPrTo("");
        setPVtmCardNo("");
    }

    const handleDenoChange = (v) => {
        Common.validateDecValue(v, setPDenomination);
        setCommValue(calcCommission(commission, commType, pQuantity, v, pRate));
    }

    const handleQuantityChange = (v) => {
        Common.validateNumValue(v, setPQuantity);
        if (pProduct === "")
            setPrTo((v * 1 + prFrom * 1) - 1);
        setCommValue(calcCommission(commission, commType, v, pDenomination, pRate));
    }

    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        if (pIsdId === "USD") {
            Common.validateDecValue(v, setUSDRate);
        }
        setCommValue(calcCommission(commission, commType, pQuantity, pDenomination, v));
    }

    const handleFromChange = (value) => {
        setPrFrom(value);
        var fr = value.id.split("^");
        var v = fr[1];
        setPrFromValue(v);
        setVtcIsd(fr[4]);
        if (fr[1] === "" || pQuantity === "") {
            setPrTo("");
        } else {
            Common.addWithInitialZeroes(fr[1], 1 * pQuantity - 1, setPrTo);
            // setPrTo((v * 1 + pQuantity * 1) - 1);
        }

        setPrPrefix(fr[8]);
        if (pSaleReload === "R") setPVtmCardNo(fr[7]);
    }

    const handleChangeIsd = (value) => {
        setDsrRate("");
        setPIsd(value);
        let a = value.id.split("^");
        setPIsdId(a[1]);
        setPAgent(null);
        setCommType("F");
        setCommission("");
        setCommValue("");
        setPrFrom(null);
        setPrFromValue("");
        const obj = {
            isd: a[1],
            location: spLocationValue,
            product: pProduct,
            trantype: "SP",
            individual: nTravellerSrno,
            billdate: hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd,
        }
        Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPRate(Math.round(resp.salerate * 100000) / 100000);//round off upto 3 digit
            setMaxPRate(resp.maxsalerate * 1);
            setMinPRate(resp.minsalerate * 1);
            setUSDRate(resp.usdratesale * 1);
        });
        if (pProduct === "VTM") {
            const obj1 = {
                hdrsrno: hdrSrno,
                location: spLocationValue,
                type: "SP",
                isd: a[1],
                product: 'VTM',
                billdate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(spNewDate),
                group: pIssuerGroup == null || pIssuerGroup == "" ? 0 : pIssuerGroup,
                account: pIssuerAccount == null || pIssuerAccount == "" ? 0 : pIssuerAccount
            }
            Common.callApi(Common.apiMasterDSR, [sid, "getlatestdsr", JSON.stringify(obj1)], result => {
                let resp = JSON.parse(result);
                setDsrRate(resp.dsrrate);
            });
        }
    }

    const saveData = (issavecorpindividualrisk) => {
        $(".loader").show();

        var totalinr = 0;
        var totalCash = 0;
        var billdate = Common.dateYMD(spNewDate);
        if (hdrSrno > 0) {
            billdate = hdrDateYmd;
        }
        var depdatedym = 0;
        if (nDepDate !== null) {
            depdatedym = Common.dateYMD(nDepDate);
        }
        for (var k = 0; k < paymentData.length; k++) {
            if (paymentData[k].tp_payment_type === "CH")
                totalCash += paymentData[k].tp_amount * 1;
            if (paymentData[k].tp_payment_type === "PB") //RC
                totalinr -= paymentData[k].tp_amount * 1;
            else totalinr += paymentData[k].tp_amount * 1;
        }



        var msg = [], i = 0;
        if (nTraveller === null || nPurpose === null || nCountry === null || nTicketNo === "" || nFlightNo === "" || nDepDate == null ||
            nDuration === "" || nExecutive === null
            //|| depdatedym < billdate
            || (corpServiceCharge > 0 && pOtherCharges < corpServiceCharge) || sourceOfFund === null ||
            (sourceOfFund != null && (sourceOfFund.id.split('^')[2] === 'OTHER' && sourceOfFundOther == ""))
            //  || (travellerCnt == "1" && (travellerPan.trim() === "" || travellerPan === null))
            || (nPurposeId != null && nPurposeId == '1' && nCorporate === null)
            || (travellerCnt == "1" && !(nResident == "1" || nResident == "2" || nResident == "3"))
            || (travellerCnt != "1" && (nResident == "1" || nResident == "2" || nResident == "3"))
            || (nPurposeId == "20" && !(nResident === "4" || nResident === "2"))
            || (nResident === "4" && !(nPurposeId == "20" || nPurposeId == "6"))
            || (nPurposeIsLoan === "0" && sourceOfFundValue === "LOAN")
            || (+nPurposeIsLoan === 1 && sourceOfFundValue === "LOAN" && +reqLoanAvailed === 1 &&
                (reqLoanAccountNo.trim() === "" || reqLoanApplicant.trim() === "" || reqLoanApplicantPan.trim() === ""
                    || reqLoanApplicantPassport.trim() === "" || reqLoanCoApplicant.trim() === "" || reqLoanCoApplicantPan.trim() === "" || reqLoanCoApplicantPassport === ""
                    || reqLoanDisbAmt === "" || reqLoanDisbDate === null || reqLoanDisbRefNo.trim() === ""))
            || panRelationship === null
            // || pan === "" 
            || panName === "" || nDob === null
            || !empType
            || ((nCorporate !== null && pan === "") || (nTraveller !== null && pan === "" && ((nResident == "1" || nResident == "2" || nResident == "3"))))
            || (+pdCommisionOnOtherCharges === 1 && pdAgent == null)
            || (+pdCommisionOnOtherCharges === 1 && pdCommission == 0)
            || (1 * pdCommission > 1 * pOtherCharges || ((nPurposeId === '20') && (totalCash > 10000) && (nEncashmentDate === null || nEncashmentNumber === "" || nEncashmentFrom === "")))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nExecutive === null ? "Executive" : '');
            msg[i++] = (nTraveller === null ? "Traveller" : '');
            msg[i++] = (((nCorporate !== null && pan === "") || (nTraveller !== null && pan === "" && ((nResident == "1" || nResident == "2" || nResident == "3")))) ? "PAN" : '');
            // msg[i++] = (travellerCnt == "1" && (travellerPan.trim() === "" || travellerPan === null) ? "Traveller PAN is mendatory." : '');
            msg[i++] = (nPurpose === null ? "Purpose" : '');
            msg[i++] = (!empType ? "Employee Type" : '');
            msg[i++] = (nCountry === null ? "Country" : '');
            msg[i++] = (nFlightNo === "" ? "Flight Number" : '');
            msg[i++] = (nTicketNo === "" ? "Ticket Number" : '');
            msg[i++] = (nDepDate === null ? "Departure Date" : '');
            msg[i++] = (nDuration === "" ? "Duration of stay abroad" : '');
            //msg[i++] = (depdatedym < billdate ? "Departure date can't be before bill date." : '');
            msg[i++] = ((corpServiceCharge > 0 && pOtherCharges < corpServiceCharge) ? "Other charges can't be less than pre-set service charges." : "");
            msg[i++] = (sourceOfFund === null ? "Source Of Fund" : '');
            msg[i++] = ((nPurposeId != null && nPurposeId == '1' && nCorporate === null) ? "Corporate." : '');
            msg[i++] = ((nPurposeIsLoan === "0" && sourceOfFundValue === "LOAN") ? "Selected purpose does not allow source of fund to be LOAN." : '');
            msg[i++] = ((travellerCnt == "1" && !(nResident == "1" || nResident == "2" || nResident == "3")) ? "Invalid Residential status for Indian resident." : '');
            msg[i++] = ((travellerCnt != "1" && (nResident == "1" || nResident == "2" || nResident == "3")) ? "Invalid Residential status for Non-Indian resident." : '');
            msg[i++] = (nPurposeId == "20" && (nResident !== "4" || nResident !== "2") ? "Only foreign-tourist/NRI are allowed for purpose RECONVERSION." : '');
            msg[i++] = ((nResident === "4" && !(nPurposeId == "20" || nPurposeId == "6")) ? "Only 'RECONVERSION' purpose is allowed for foreign-tourist." : '');
            msg[i++] = ((((nPurposeId === '20') && (totalCash > 10000) && (nEncashmentNumber === ""))) ? "Encashment Number." : '');
            msg[i++] = ((((nPurposeId === '20') && (totalCash > 10000) && (nEncashmentDate === null))) ? "Encashment Date." : '');
            msg[i++] = ((((nPurposeId === '20') && (totalCash > 10000) && (nEncashmentFrom === ""))) ? "Encashed From." : '');
            msg[i++] = (panRelationship === null ? "Pan Relatiionship." : '');
            // msg[i++] = (pan === "" ? "Pan." : '');
            msg[i++] = (panName === "" ? "Pan Name." : '');

            msg[i++] = ((+pdCommisionOnOtherCharges === 1 && pdAgent == null) ? "Select Agent" : '');
            msg[i++] = ((+pdCommisionOnOtherCharges === 1 && pdCommission == 0) ? "fill Commission on Other Charges" : '');
            msg[i++] = ((1 * pdCommission > 1 * pOtherCharges) ? "Commission on other charges should not be greater than GST inclusive other charges received." : '');

            if (nCorporate != null)
                msg[i++] = (nDob === null ? "Inception Date." : '');
            else
                msg[i++] = (nDob === null ? "Date of birth." : '');

            if (sourceOfFund != null) {
                msg[i++] = ((sourceOfFund.id.split('^')[2] === 'OTHER' && sourceOfFundOther == "") ? "Enter Source Of Income." : '');
            }
            if (+reqLoanAvailed === 1) {
                msg[i++] = (reqLoanAccountNo.trim() == "" ? "Loan Account No" : '');
                msg[i++] = (reqLoanApplicant.trim() == "" ? "Loan Applicant" : '');
                msg[i++] = (reqLoanApplicantPan.trim() == "" ? "Loan Applicant PAN" : '');
                msg[i++] = (reqLoanApplicantPassport.trim() == "" ? "Loan Applicant Passport" : '');
                msg[i++] = (reqLoanCoApplicant.trim() == "" ? "Loan Co Applicant" : '');
                msg[i++] = (reqLoanCoApplicantPan.trim() == "" ? "Loan Co Applicant Pan" : '');
                msg[i++] = (reqLoanCoApplicantPassport.trim() == "" ? "Loan Co Applicant Passport" : '');
                msg[i++] = (reqLoanDisbAmt.trim() == "" ? "Loan Disb. Amount" : '');
                msg[i++] = (reqLoanDisbDate === null ? "Loan Disb. Date" : '');
                msg[i++] = (reqLoanDisbRefNo.trim() == "" ? "Loan Disb. Ref no" : '');
            }

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pTotalAmount != totalinr) {
            $(".loader").hide();
            setMsgText("Total amount of payment must be equal to calculated INR.");
            setMsgBox(true);
        }
        else if (acRemark === '' && issavecorpindividualrisk === true) {
            setShowModal(false);
            setMsgText('Please fill Remark!');
            setMsgBox(true);
            $(".loader").hide();
        } else if (scrMode === 'A' && spProductList.length < 1) {
            setMsgText("Productlist can't be empty.");
            setMsgBox(true);
            $(".loader").hide();
        } else if (!(nSubExecutive == null || nSubExecutive?.id.trim() == "0") && isCommission == "1") {
            console.log(nSubExecutive, ' ', isCommission);
            setMsgText("In Case of SUB EXECUTIVE you can not add COMMISSION.");
            setMsgBox(true);
            $(".loader").hide();
        } else if (nCorporate && (pTotalAmount * 1) < (pTaxableVal * 1) + (pSgst * 1) + (pIgst * 1) + (pCgst * 1) + (pUgst * 1)) {
            setMsgText("Total Amount should be Greater than Taxable Value+SGST+IGST+CGST+UGST");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            setShowModal(false);
            const obj = {
                srno: hdrSrno,
                spLocationValue: spLocationValue,
                locationwithstate: spLocation,
                spSaleType: spSaleType,
                spNewDate: hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd,
                nCorporate: nCorporate,
                nCountry: nCountry,
                nState: nState.value,
                nResident: nResident,
                nTraveller: nTraveller,
                nPurpose: nPurpose,
                nEncashmentNumber: nEncashmentNumber,
                nEncashmentFrom: nEncashmentFrom,
                nEncashmentDate: nEncashmentDate,
                nExecutive: nExecutive,
                nSubExecutive: nSubExecutive,
                pForexTotal: pForexTotal,
                nFlightNo: nFlightNo,
                nTicketNo: nTicketNo,
                nVisaType: nVisaType,
                nDepDate: Common.dateYMD(nDepDate),
                nTicketClass: nTicketClass,
                nDuration: nDuration,
                nPanForm60: nPanForm60,
                nMode: nMode,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pTcs: pTcs,
                pTcsRate: pTcsRate,
                pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal,
                pTotalAmount: pTotalAmount,
                nTravellerCode: nTravellerCode,
                //randomString: randomString,
                spProductList: spProductList,
                paymentData: paymentData,
                prd_usd_rate: usdRate == "" ? 0 : usdRate,

                radioType: radioType,
                spLocation: spLocationValue,
                //ppCorporate: ppCorporate,
                spIndividual: spIndividual,
                spSrnoTo: spSrnoTo,
                spSrnoFrom: spSrnoFrom,
                spFromDate: Common.dateYMD(spFromDate),
                spToDate: Common.dateYMD(spToDate),
                ppStateType: spStateType,
                ppStateValue: spStateValue,
                sourceOfFund: sourceOfFund,
                sourceOfFundOther: sourceOfFundOther,
                nRemark1: nRemark1,
                nRemark2: nRemark2,
                travellerPan: pan,
                purpose: nPurposeId,
                loan: reqLoanAvailed,
                reqLoanAccountNo: reqLoanAvailed === "0" ? "" : reqLoanAccountNo,
                reqLoanApplicant: reqLoanAvailed === "0" ? "" : reqLoanApplicant,
                reqLoanApplicantPassport: reqLoanAvailed === "0" ? "" : reqLoanApplicantPassport,
                reqLoanApplicantPan: reqLoanAvailed === "0" ? "" : reqLoanApplicantPan,
                reqLoanCoApplicant: reqLoanAvailed === "0" ? "" : reqLoanCoApplicant,
                reqLoanCoApplicantPassport: reqLoanAvailed === "0" ? "" : reqLoanCoApplicantPassport,
                reqLoanCoApplicantPan: reqLoanAvailed === "0" ? "" : reqLoanCoApplicantPan,
                reqLoanDisbRefNo: reqLoanAvailed === "0" ? "" : reqLoanDisbRefNo,
                reqLoanDisbDate: Common.dateYMD(reqLoanDisbDate),
                reqLoanDisbAmt: reqLoanDisbAmt === "" || reqLoanAvailed === "0" ? 0 : reqLoanDisbAmt,
                reqLoanInstName: reqLoanAvailed === "0" ? "" : reqLoanInstName,
                panRelationshipCode: panRelationShipCode,
                pan: pan,
                panName: panName,
                nDob: Common.dateYMD(nDob),
                nManualno: nManualno,
                issavecorpindividualrisk: issavecorpindividualrisk,
                riskValue: riskValue,
                riskRemark: acRemark,
                pTcsTaxable: pTcsTaxable,
                pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,
                empType: empType,
                cntIssue: cntIssue,
                travellerCnt: travellerCnt,
                agentGroup: agentGroup || 0,
                agentAccount: agentAccount || 0,
                pdCommission: pdCommission || 0,
                pdCommisionOnOtherCharges: pdCommisionOnOtherCharges || '',
                individualName: individualName,
                individualAddress: individualAddress,
                corporateName: corporateName,
                corporateAddress: corporateAddress,
                individualId: individualId,
                individualNumber: individualNumber,

            }
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (+userRight.edit === 1 && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'SP', spLocationValue));
            }
            let isOk = true;
            var msg = "";
            if (isOk) {
                Common.callApi(Common.apiTranSP, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                    $(".loader").hide();
                    let resp = JSON.parse(result);
                    if (resp?.blacklistedYN?.isBlackListed && +resp?.blacklistedYN?.isBlackListed === 1) {
                        setMsgText(resp.blacklistedYN.name + " can't saved.Traveller/Corporate is Red Flags." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id + " " + "</br> Contact to compliance department.");
                        setMsgBox(true);
                        return;
                    }
                    if (resp.msg === "MSG0000") {
                        setSPList(resp.spList);
                        // setScrMode("Q");
                        setKey("INFO");
                        // listSPdata();
                        let paramDate = Common.dateYMD(spNewDate);
                        if (hdrSrno > 0) {
                            paramDate = hdrDateYmd;
                        }
                        // fillViewForm(resp.srno, paramDate);
                        if (typeof resp?.irn?.Status !== "undefined") {
                            if (resp.irn.Status == "0") {
                                msg = ", IRN generation failed";
                                alert(JSON.stringify(resp.irn.ErrorDetails));
                            }
                        }
                        if (resp?.printhtml != "" && +Common.Billprint === 1) {
                            var newWindow = window.open();
                            if (newWindow) {
                                newWindow.document.write(resp?.printhtml);
                            }
                        }
                        setMsgBox(true);
                        setMsgText(Common.getMessage(resp.msg) + msg);
                        setTranAuditTrail([]);
                        expireUnlock();
                        setAcRemark("");

                        setScrMode("")
                        setRadioType("S")
                        setSPSrnoFrom(resp.srno)
                        setSPSrnoTo(resp.srno)
                    } else if (resp.msg === "CREDIT_PERIOD_EXCEEDED" || resp.msg === "CREDIT_LIMIT_EXCEEDED") {
                        setMsgBoxCreditLimit(true);
                        setMsgTextCreditLimit(resp.msg + ', ' + 'Do you want to request for additional limit?');
                    } else if (resp.msg['riskvalue'] === '2') {
                        setShowModal(true);
                        setRiskModalBoxText(resp.msg['ledgername'] + " is medium risk. Please take the extra documentation.");
                        setRiskValue(resp.msg['riskvalue']);
                    } else if (resp.msg['riskvalue'] === '3') {
                        setMsgBox(true);
                        setMsgText(resp.msg['ledgername'] + " is high risk.\nTransaction can not be saved.\n Please contact to compliance department.");
                    } else {
                        setMsgBox(true);
                        setMsgText(resp.msg);
                    }
                });
            }
        }
    }

    const expireUnlock = () => {
        if ((scrMode == 'E' && unlockRequestType !== "SELF")) {
            const obj = {
                srno: hdrSrno,
                type: 'SP',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'TRAN_SP'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        // console.log(Common.editDateLimit);
        const vtmactivationunlock = false;


        const obj = {
            srno: hdrSrno,
            type: 'SP',
            pageright: 'TRAN_SP',
            location: spLocationValue,
            spLocation: spLocationValue
        }
        // Common.callApi(Common.apiTranSP, [sid, "checkForvtmActivation", JSON.stringify(obj)], result => {
        //     $(".loader").hide();
        //     let resp = JSON.parse(result);
        //     if (resp.counter === 1) {
        //         setMsgBox(true);
        //         setMsgText(resp.msg);
        //     } else {
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (spProductList.length > 0) {
                    setDisableOtherCharge(false);
                }
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SP', trannumber: hdrSrno, location: spLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })
        // }
    }
    // )
    // }

    // const editData = () => {
    //     setScrMode("E");
    // }

    const otherChargeChange = (v, corpChangevalue = "") => {
        // let val = Math.round(v * 100) / 100;
        let val = v;
        Common.validateDecValue(val, setPOtherCharges);
        const obj = {
            tranType: "SP",
            type: "SALE",
            pOtherCharges: val === "" ? 0 : val,
            ppStateType: spStateType,
            ppStateValue: spStateValue,
            nState: nState.value,
            nCorporate: corpChangevalue != "" ? corpChangevalue : nCorporate,
            travellerPan: pan,
            loan: +reqLoanAvailed === 1 ? "Y" : "N",
            purpose: nPurposeId,
            srno: hdrSrno,
            spLocationValue: spLocationValue,
            pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,
        }
        if (Common.isPurelyNumeric(val)) {
            calculateGST(spProductList, obj);
        }
    }
    const selfDeclarationChange = (v) => {
        Common.validateDecValue(v, setPSelfDeclaration);
        const obj = {
            tranType: "SP",
            type: "SALE",
            pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges,
            pSelfDeclaration: v === "" ? 0 : v.trim(),
            ppStateType: spStateType,
            ppStateValue: spStateValue,
            nState: nState.value,
            nCorporate: null,
            travellerPan: pan,
            loan: +reqLoanAvailed === 1 ? "Y" : "N",
            purpose: nPurposeId,

            srno: hdrSrno,
            spLocationValue: spLocationValue,
        }
        if (Common.isPurelyNumeric(v.trim())) {
            calculateGST(spProductList, obj);
        }
    }

    const checkVtmExist = (obj) => {
        return false; // this is added on date 25-04-2025
        return spProductList.some(row =>
            row.prd_from === obj.prd_from &&
            row.prd_group === obj.prd_group &&
            row.prd_isd === obj.prd_isd &&
            row.prd_account === obj.prd_account &&
            row.vtcIsd === obj.vtcIsd
        );
    }

    const checkMultiCurrencyVtmCardNo = (obj) => {
        for (let i = 0; i < spProductList.length; i++) {
            if (spProductList[i].prd_sale_reload === "S") {
                if (spProductList[i].prd_from === obj.prd_from && spProductList[i].prd_group === obj.prd_group &&
                    spProductList[i].vtcIsd === obj.vtcIsd && spProductList[i].prd_account === obj.prd_account) {
                    if (spProductList[i].prd_card_no !== obj.prd_card_no) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    const addProduct = async (issavevtm) => {
        $(".loader").show();
        var msg = [], i = 0;
        var isSaveVtm = issavevtm;
        if ((pIsd == null || pDenomination === "" || pQuantity === "" || pRate === "" || 1 * pRate === 0)
            ||
            (pProduct === "VTM" && (prFrom == null || pVtmCardNo === "" || pIssuer == null))
            ||
            (+isCommission === 1 && (commType === "" || pAgent === null || commValue === ""))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd == null ? "Please select Isd." : '');
            msg[i++] = (pDenomination === '' ? "Please fill Denomination." : '');
            msg[i++] = (pQuantity == '' ? "Please fill Quantity." : '');
            msg[i++] = (pRate == '' || pRate * 1 === 0 ? "Please fill Rate." : '');
            if (pProduct === "VTM" && (prFrom == null || prTo == "" || pIssuer == null)) {
                msg[i++] = (pIssuer == null ? "Issuer." : '');
                msg[i++] = (prFrom == null ? "From." : '');
                msg[i++] = (pVtmCardNo == '' ? "Card Number." : '');
            }
            if (+isCommission === 1 && (commType === "" || pAgent === null || commValue === "")) {
                msg[i++] = (pAgent == null ? "Agent." : '');
                msg[i++] = (commType == '' ? "Commission type." : '');
                msg[i++] = (commValue == '' ? "Commission value." : '');
            }
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pProduct === "VTM" && (prTo * 1 - prFrom * 1 > 100)) {
            $(".loader").hide();
            setMsgText("'To' must be less than 100.");
            setMsgBox(true);
        } else if (maxPRate != 0 && minPRate != 0 && (pRate > maxPRate || pRate < minPRate)) {
            $(".loader").hide();
            msg[i++] = (pRate > maxPRate ? "Maximum rate is " + maxPRate : '');
            msg[i++] = (pRate < minPRate ? "Minimum rate is " + minPRate : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pProduct === 'VTM' && ((pRate * 1) < (dsrRate * 1)) && !isSaveVtm) {
            $(".loader").hide();
            setMsgTextYNvtm("Do you real want to sell below DSR.");
            setMsgBoxYNvtm(true);
        } else {
            $(".loader").hide();
            var isdarr = pIsd.id.split("^");
            var agentgrp = 0;
            var agentaccnt = 0;
            var agentname = "";

            var issgrp = 0;
            var issaccnt = 0;
            if (pAgent !== null) {
                var agent = pAgent.id.split("^");
                agentgrp = agent[1];
                agentaccnt = agent[2];
                agentname = agent[5];
            }
            if (pIssuer !== null) {
                var issuer = pIssuer.id.split("^");
                issgrp = issuer[1];
                issaccnt = issuer[2];
            }
            var usdAmt = 0;
            if (usdRate != "" && usdRate != 0) {
                // if(isdarr[1] === 'USD'){
                //     usdAmt =
                // }
                usdAmt = (pRate * pQuantity * pDenomination) / usdRate;
            }
            const obj = {
                tranType: "SP",
                type: "SALE",
                uniquekey: Common.getRandomString(15),
                prd_line_no: 1 * productLineNo + 1,
                prd_location: spLocationValue,
                prd_type: 'SP',
                prd_srno: hdrSrno,
                prd_isd: isdarr[1],
                prd_date: hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd,
                prd_product: pProduct,
                prd_deno: pDenomination,
                prd_qty: pQuantity,
                prd_rate: pRate,
                prd_amount: Math.round(pRate * pQuantity * pDenomination),
                prd_from: prFromValue,
                prd_prefix: prPrefix,
                prd_to: prTo,
                prd_group: issgrp,
                prd_account: issaccnt,
                prd_agent_group: agentgrp,
                prd_agent_ledger: agentaccnt,
                prd_card_no: pVtmCardNo,
                isd_name: isdarr[2],
                prd_commission_type: commType,
                prd_commission_value: commValue == "" ? 0 : commValue,
                prd_commission: commission == "" ? 0 : commission,
                prd_sale_reload: pProduct === "CN" ? "" : pSaleReload,
                nCorporate: nCorporate,
                nState: nState.value,
                pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges,
                ppStateType: spStateType,
                ppStateValue: spStateValue,
                scrMode: scrMode,
                prFrom: prFrom,
                prd_usd_rate: usdRate == "" ? 0 : Number(usdRate).toFixed(2),
                prd_usd_amount: Number(usdAmt).toFixed(2),
                delny: "Y",
                isCommission: isCommission,
                prd_agent_name: agentname,
                travellerPan: pan,
                loan: +reqLoanAvailed === 1 ? "Y" : "N",
                purpose: nPurposeId,
                vtcIsd: vtcIsd,
                prd_vtm_status: 'PENDING',
                prd_vtm_released_status: 0,

                srno: hdrSrno,
                spLocationValue: spLocationValue,
                pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,
            }
            if (pProduct === "VTM") {
                if (checkVtmExist(obj)) {
                    setMsgBox(true);
                    setMsgText("VTM already added in list.");
                    return;
                }
                if (!checkMultiCurrencyVtmCardNo(obj)) {
                    setMsgBox(true);
                    setMsgText("Card number of multi-currency card does not match.");
                    return;
                }
            }
            // var productlist;
            // const isdAlreadyExist = isIsdAlreadyExist(obj);
            // if (isdAlreadyExist.isIsdExist && "CN") {
            //     productlist = Common.arrayChangeItem(spProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_qty', isdAlreadyExist.prdRow.prd_qty);
            //     productlist = Common.arrayChangeItem(spProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_amount', isdAlreadyExist.prdRow.prd_amount);
            //     productlist = Common.arrayChangeItem(spProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_usd_amount', isdAlreadyExist.prdRow.prd_usd_amount);
            // } else {
            //     productlist = Common.arrayAddItem(spProductList, obj);
            // }
            if (pProduct === "CN") {
                let stock = await Common.checkAvailableStock(obj, spProductList);
                if (!stock) {
                    setMsgBox(true);
                    setMsgText("Not able to add " + obj.prd_isd + ", stock getting negative.");
                    return;
                }
            }
            var productlist = Common.arrayAddItem(spProductList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                // TLine: productLineNo + 1,
                TLoc: spLocationValue,
                TType: 'SP',
                // TNum?
                Product: pProduct,
                ISD: isdarr[2],
                Deno: pDenomination,
                Quantity: pQuantity,
                Rate: pRate,
                Amount: pRate * pQuantity * pDenomination,
                // ...(pProduct === "ETC" ? {
                ProductFrom: prFrom,
                ProductTo: prTo,
                ProductPrefix: prPrefix,
                ProductGroup: issgrp,
                ProductAccout: issaccnt,
                // } : {}),
                CommsnType: commType,
                AgentGroupCode: agentgrp,
                AgentLedgerCode: agentaccnt,
                CommsnRate: commValue == "" ? 0 : commValue,
                CommsnAmount: commission == "" ? 0 : commission,

            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setSPProductList(productlist);
            setCounter(counter + 1);
            setProductLineNo(1 * productLineNo + 1);
            setPIsd(null);
            setPIssuer(null);
            setPDenomination("");
            if (pProduct === "CN") setPQuantity("");
            setPRate("");
            setPrPrefix("");
            setPrFrom(null);
            setPrFromValue("");
            setPrTo("");
            setPVtmCardNo("");
            setCommValue("");
            //setCommission("");
            setCommType("F");
            setPAgent(null);

            setCommission("");
            calculateGST(productlist, obj);
            setAgentName("");
            setAgentPan("");
            setAgentAddress("");
        }
    }

    const isIsdAlreadyExist = (obj) => {
        var isIsdExist = false;
        var prdRow = {};
        for (var i = 0; i < spProductList.length; i++) {
            if (spProductList[i].prd_isd === obj.prd_isd && spProductList[i].prd_deno === obj.prd_deno && spProductList[i].prd_product === obj.prd_product) {
                prdRow.prd_line_no = spProductList[i].prd_line_no;
                prdRow.prd_qty = 1 * spProductList[i].prd_qty + obj.prd_qty * 1;
                prdRow.prd_amount = (prdRow.prd_qty * obj.prd_rate * obj.prd_deno).toFixed(2);
                prdRow.prd_usd_amount = (prdRow.prd_amount / usdRate).toFixed(2);
                isIsdExist = true;
                break;
            }
        }
        return { isIsdExist: isIsdExist, prdRow: prdRow };
    }

    const calculateGST = (productlist, obj) => {
        obj.reqLoanDisbAmt = reqLoanDisbAmt === "" || reqLoanAvailed === "0" ? 0 : reqLoanDisbAmt
        Common.callApi(Common.apiCalcTaxable, [sid, "calcinvoice", JSON.stringify(productlist), JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPForexTotal(resp.fxamt);
            setPSgst(resp.sgst);
            setPTotalAmount(resp.totalamt);
            setPTaxableVal(resp.taxablevalue);
            setPRoundOff(resp.roundoff);
            setPCgst(resp.cgst);
            setPIgst(resp.igst);
            setPUgst(resp.ugst);
            setPTcs(resp.tcs);
            setPTcsRate(resp.tcsRate);
            setPTcsTaxable(resp.tcsTaxable);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * resp.totalamt - amt);
        });
    }

    const deleteProduct = (key) => {
        const itemToDelete = spProductList.find(item => item.uniquekey === key);

        if (itemToDelete) {
            const formattedItem = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: spLocationValue,
                TType: 'SP',
                Product: itemToDelete.prd_product,
                ISD: itemToDelete.isd_name,
                Deno: itemToDelete.prd_deno,
                Quantity: itemToDelete.prd_qty,
                Rate: itemToDelete.prd_rate,
                Amount: itemToDelete.prd_amount,
                ProductFrom: itemToDelete.prd_from,
                ProductTo: itemToDelete.prd_to,
                ProductPrefix: itemToDelete.prd_prefix,
                ProductGroup: itemToDelete.prd_group,
                ProductAccout: itemToDelete.prd_account,
                AgentGroupCode: itemToDelete.prd_agent_group,
                AgentLedgerCode: itemToDelete.prd_agent_ledger,
                CommsnType: itemToDelete.prd_commission_type,
                CommsnRate: itemToDelete.prd_commission_value,
                CommsnAmnt: itemToDelete.prd_commission,
            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        const obj = {
            tranType: "SP",
            type: "SALE",
            pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
            ppStateType: spStateType,
            ppStateValue: spStateValue,
            nState: nState.value,
            nCorporate: nCorporate,
            travellerPan: pan,
            loan: +reqLoanAvailed === 1 ? "Y" : "N",
            purpose: nPurposeId,
            pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,

            srno: hdrSrno,
            spLocationValue: spLocationValue,
        }
        const productlist = Common.arrayRemoveItem(spProductList, "uniquekey", key);
        setSPProductList(productlist);
        setCounter(counter - 1);
        calculateGST(productlist, obj);
    }

    const print = (printflag) => {
        $(".loader").show();
        if (isIrnGenerated === "0" && isIrnApplicable === "Y") {
            setMsgText("Irn not generated.");
            $(".loader").hide();
            setMsgBox(true);
        } else {
            const obj = {
                srno: hdrSrno,
                location: spLocationValue,
                type: 'SP',
                pType: 'SP',
                printFlag: printflag,
                nCorporate: nCorporate,
                nIndivualSrno: nTravellerSrno,
                pSaleReload: pSaleReload,
                // pType: '',

            }
            Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            });
        }
    }

    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && nTraveller != null) setScrIndividual("E");
        else setScrIndividual("A");
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        console.log('hideIndividualProfile', val, individualsrno);
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with Red Flags individual." + master + " " + dataid + "</br>Contact to Compliance Department. ");
            setMsgBox(true);
            setNTraveller(null);
            return;
        }
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                idSrno: idSrno,
                type: "SP"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                const desc = resp.desc.split("^");
                if (resp.id === "") setNTraveller(null);
                else {
                    handleTravellerChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                    // setNTraveller({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                    // setTravellerPan(resp.desc.split('^')[1].trim());
                };
            });
        }
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }

    const handlePaymentType = (v) => {
        $(".loader").show();
        console.log("Payment Type", v);
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            ldgType = "CASH";
        } else if (v === "BN") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "CQ") {
            ldgType = "CHEQUE";
        } else if (v === "RC") {
            ldgType = "WALKIN";
            if (nCorporate !== null) {
                setPdAccount(nCorporate);
                const corp = nCorporate.id.split('^');
                setCorpName(corp[5]);
                setDisablePaymentAccount(true);
                $(".loader").hide();
                return;
            }
        } else {
            ldgType = "WALKIN";
        }
        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }

    const isCreditAllowed = (obj1) => {
        return new Promise((resolve, reject) => {
            Common.callApi(Common.apiTranPP, [sid, "creditAllowed", JSON.stringify(obj1)], result => {
                const response = JSON.parse(result);
                resolve(response);
            });
        });
    }

    // const checkPaymentMethods = () => {
    //     var isOk = true;
    //     return paymentData.some(row =>
    //         row.prd_from === obj.prd_from
    //     );
    //     return isOk;
    // }


    const addPayment = () => {
        console.log("Payment account :", pdAccount);
        $(".loader").show();
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            $(".loader").hide();
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (paymentData.length > 0 && (pdPaymentType === "CH" || paymentData[0].tp_payment_type === "CH")) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Either cash or bank/cheque/receivable is allowed.");
            return;
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1
            || (pdPaymentType === 'CQ' && (pdChequeNum === "" || chequeBankName === "" || chequeDate === null))
            || (pdPaymentType === "BN" && pdChequeNum === "") || (pdPaymentType === "RC" && pdRemark === "")
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            msg[i++] = ((pdPaymentType === "RC" && pdRemark === "") ? "Remark " : '');
            if (pdPaymentType === 'CQ' && (pdChequeNum === "" || chequeBankName === "" || chequeDate === null)) {
                msg[i++] = (pdChequeNum === "" ? "Cheque Number." : '');
                msg[i++] = (chequeBankName === "" ? "Bank Name." : '');
                msg[i++] = (chequeDate === null ? "Cheque Date" : '');
            }
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (pdChequeNum === "" ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $(".loader").hide();
            var creditAllowed = true;
            if (creditAllowed) {
                // Check for duplicate reference number if payment type is BN and CQ
                if ((pdPaymentType === "BN" || pdPaymentType === "CQ") && pdChequeNum !== "") {
                    const isDuplicateRef = paymentData.some(item =>
                        item.tp_payment_type === pdPaymentType &&
                        item.tp_cheque === pdChequeNum
                    );

                    if (isDuplicateRef) {
                        msg[i++] = `Reference number '${pdChequeNum}' is already used for '${pdPaymentType}'.`;
                        setMsgText(Common.buildMessageFromArray(msg));
                        setMsgBox(true);
                        return;
                    }
                }


                var grp = 0;
                var accnt = 0;
                var accntname = '';
                if (pdAccount !== null) {
                    var a = pdAccount.id.split("^");
                    grp = a[1];
                    accnt = a[2];
                    if (pdPaymentType === "CH" || pdPaymentType === 'CQ' || pdPaymentType === 'RC') {
                        accntname = a[4];
                    } else {
                        accntname = a[5];
                    }
                }
                const obj = {
                    uniquekey: Common.getRandomString(10),
                    tp_line_no: paymentLineNo + 1,
                    tp_location: spLocationValue,
                    tp_srno: hdrSrno,
                    //randomString: randomString,
                    tp_payment_type: pdPaymentType,
                    tp_account: accnt,
                    tp_group: grp,
                    mvli_ledger_name: (nCorporate !== null && pdPaymentType === 'RC') ? corpName : accntname,
                    tp_amount: pdAmount,
                    tp_cheque: pdChequeNum,
                    tp_cheque_bank: chequeBankName,
                    tp_cheque_date: pdPaymentType === "CQ" ? Common.dateYMD(chequeDate) : "NULL",
                    tp_type: "SP",
                    tp_remark: pdRemark,
                    delny: 'Y'
                }
                // const existingItem = Common.isSamePaymentMethod(obj, paymentData);
                // if (existingItem) {
                //     existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
                //     existingItem.tp_cheque = pdChequeNum;
                //     existingItem.tp_remark = pdRemark;
                // } else {
                const paymentdata = Common.arrayAddItem(paymentData, obj);
                setPaymentData(paymentdata);
                const obj2 = {
                    TabType: "Payment",
                    AType: "A",
                    ALineNo: tranAuditTrail.length + 1,
                    // TLine: paymentLineNo + 1,
                    TLoc: spLocationValue,
                    TType: 'SP',
                    PaymentType: pdPaymentType,
                    PaymentLedgerCode: accnt,
                    PaymentGroupCode: grp,
                    PaymentAccountName: accntname,
                    PaymentAmount: pdAmount,
                    // ...(pdPaymentType == "BN" ? {
                    ReferenceNo: pdChequeNum,
                    Remark: pdRemark,
                    // } : {}),

                }
                if (+userRight.edit === 1 && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                }
                // }
                setPdPaymentType("");
                setPaymentLineNo((1 * paymentLineNo) + 1);
                //setPdAmount("");
                setPdAccount(null);
                setPdChequeNum("");
                setChequeBankName("");
                setChequeDate(null);
                setPdRemark("");
                setCounter(counter + 1);
                const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
                setPdAmount(1 * pTotalAmount - amt);
            } else {
                setMsgBox(true);
                setMsgText("Credit not allowed to selected account");
            }
        }
    }

    const deletePayment = (value) => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            location: spLocationValue,
            type: 'SP',
            payment_line_no: value.tp_line_no
        }
        Common.callApi(Common.apiTranPP, [sid, "shouldDelete", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (hdrSrno < 1 || resp.isdeletable == '1') {
                const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value.uniquekey);
                setPaymentData(paymentdata);
                const amt = paymentdata.reduce((total, payment) => total + payment.tp_amount * 1, 0);
                setPdAmount(1 * pTotalAmount - amt);
                const itemToDelete = paymentData.find(item => item.uniquekey === value.uniquekey);

                if (itemToDelete) {
                    const formattedItem = {
                        TabType: "Payment",
                        ALineNo: tranAuditTrail.length + 1,
                        AType: "D",
                        TLoc: spLocationValue,
                        TType: 'SP',
                        PaymentType: itemToDelete.tp_payment_type,
                        PaymentGroupCode: itemToDelete.tp_group,
                        PaymentLedgerCode: itemToDelete.tp_account,
                        PaymentAccountName: itemToDelete.mvli_ledger_name,
                        PaymentAmount: itemToDelete.tp_amount,
                        ReferenceNo: itemToDelete.tp_cheque,
                    };
                    if (+userRight.edit === 1 && scrMode === 'E') {
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                    }

                }
                setPaymentData(Common.arrayRemoveItem(paymentData, "uniquekey", value.uniquekey));
            } else {
                setMsgBox(true);
                setMsgText("Cannot delete, amount aleady knockedoff.");
            }
        });
        setCounter(counter - 1);
    }

    const handleAgentChange = (value) => {
        setPAgent(value);
        Common.callApi(Common.apiTranPP, [sid, "getAgentInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setAgentName(resp.mvli_ledger_legal_name);
            setAgentPan(resp.mvli_pancard);
            setAgentAddress(resp.mvli_address);
        });
        setCommType("F");
        /*
            Common.callApi(Common.apiLedger, [sid, "getisdcommission", value.id, pIsdId, pProduct], result => {
                console.log(result);
                let resp = JSON.parse(result);    
                setCommType(resp.type);     // for multi options
                setCommission(resp.value);
                var commvalue;
                if (resp.type === "P" || resp.type === "R") {
                    commvalue = calcCommission(resp.value, resp.type, pQuantity, pDenomination, pRate);
                } else {
                    commvalue = resp.value;
                }
                setCommValue(commvalue);
                
            });
        */
    }

    const calcCommission = (value, type, quantity, deno, rate) => {
        var comm = 0;
        if (type === "P") {
            comm = (value * quantity * deno) / 100;
        } else if (type === "R") {
            comm = (quantity * deno * rate) * (value / 100);
        } else {
            comm = value;
        }
        if (comm > 0) return comm.toFixed(2);
        return comm;
    }

    const commissionTypeChange = (v) => {
        setCommType(v);
        setCommission("");
        setCommValue("");
    }

    const handleCommissionCalc = (v) => {
        Common.validateDecValue(v, setCommission);
        setCommValue(calcCommission(v * 1, commType, pQuantity, pDenomination, pRate));
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: spLocationValue, trannumber: hdrSrno, type: 'SP' });
    }

    const handleIssuerChange = (value) => {
        setPIssuer(value);
        var iss = value.id.split("^");
        setPIssuerGroup(iss[1]);
        setPIssuerAccount(iss[2]);
        setPrFrom(null);
        setPrFromValue("");
        const obj1 = {
            hdrsrno: hdrSrno,
            location: spLocationValue,
            type: "SP",
            isd: pIsdId == null ? "" : pIsdId,
            product: 'VTM',
            billdate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(spNewDate),
            group: iss[1] == null || iss[1] == "" ? 0 : iss[1],
            account: iss[2] == null || iss[2] == "" ? 0 : iss[2]
        }
        Common.callApi(Common.apiMasterDSR, [sid, "getlatestdsr", JSON.stringify(obj1)], result => {
            let resp = JSON.parse(result);
            setDsrRate(resp.dsrrate);
        });
    }

    const handleSaleTypeChange = (v) => {
        setPSaleReload(v);
        setPrFrom(null);
        setPrFromValue("");
        setPrTo("");
        setPVtmCardNo("");
        setPDenomination("");
        setPRate("");
    }
    const handlePreTransactionInfo = () => {
        $(".loader").show();
        setShowPreviousTransactionModal(true);
        const obj = {
            srno: nTravellerSrno
        }
        Common.callApi(Common.apiTranSP, [sid, "getpretran", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            if (res === "") {
                alert("Select Individual First ");
                setPreTransaction("");
            } else {
                setPreTransaction(res);
            }
        });

    }
    const handleLRSTransactionInfo = () => {
        $(".loader").show();
        setShowLRSTransactionModal(true);
        const obj = {
            srno: nTravellerSrno
        }
        Common.callApi(Common.apiTranSP, [sid, "getlrntran", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            if (res === "") {
                alert("Select Individual First ");
                setLrsTransaction("");
            } else {
                setLrsTransaction(res);
            }

        });
    }

    const createCreditLimit = () => {
        $("loader").show();
        const obj = {
            paymentData: paymentData,
            spNewDate: Common.dateYMD(spNewDate),
            nTraveller: nTraveller,
            srno: hdrSrno,
            spLocationValue: spLocationValue
        }
        Common.callApi(Common.apiCreditLimit, [sid, "addlimit", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            $("loader").hide();
            setMsgBoxCreditLimit(false);
            setMsgBox(true);
            setMsgText(resp.msg);
        });
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            productRef.current.focus();
        }
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "SP", trannumber: hdrSrno, trancategory: "T", location: spLocationValue });
    }
    const handleRateCard = () => {
        const obj = {
            location: spLocationValue,
            product: filterProduct

        }
        Common.callApi(Common.apiMasterIBR, [sid, 'getratecard', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            const newWindow = window.open('about:blank', '_blank');
            var ratecarddate = resp[0]["mrc_date"];
            newWindow.document.write(`
                <html>
                <head>
                    <title>Rate Card</title>
                    <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td  {
                        border: 2px solid black;
                        padding: 8px;
                        text-align: left;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                    .header {
                        display: flex;
                        justify-content: space-between; /* Aligns items to opposite corners */
                        align-items: center; /* Vertically centers items */
                    }
                    .header img {
                        width: 300px; /* Adjust the width as needed */
                        height: auto;
                    }
                    .container{
                    background: aliceblue;
                    padding: 20px;
                    }
                    </style>
                </head>
                <body>
                <div class= "container">
                    <div class="header">
                    <img src="img/logo.png" alt="Rate Card Image" />
                        <div>
                            <h1>Zenith Forex</h1>
                            <p>Card Rate as on ${ratecarddate}<p>
                        </div>
                    </div>
                    <table>
                    <thead>
                        <tr>
                        <th>Code</th>
                        <th>Currencies</th>
                        <th>Product</th>
                        <th>Sale Rate</th>
                        <th>Max Sale Rate</th>
                        <th>Min Sale Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${resp.map((item) => `
                        <tr>
                            <td>${item.mrc_isd}</td>
                            <td>${item.isd_name}</td>
                            <td>${item.mrc_product === "C" ? "CN" : item.mrc_product === "R" ? "Card" : item.mrc_product === "D" ? "DD" : item.mrc_product === "T" ? "TT" : ""}</td>
                            <td>${item.mrc_sale_rate}</td>
                            <td>${item.mrc_max_salerate}</td>
                            <td>${item.mrc_min_salerate}</td>
                        </tr>
                        `).join('')}
                    </tbody>
                    </table>
                </div>
                </body>
                </html>

              `);

            newWindow.document.close(); // 
        });
    }

    const handleShowCommissionDetail = () => {
        setShowCommissionDetail(true);
    }

    const cancelBillFinalModal = () => {
        setMsgBoxCancelBill(true);
        setMsgTextCancelBill("Alert!");
        setIrnCancelDeclaration(false);
        setIrnCancelReason("");
        setIrnCancelLabel("I confirm the deletion of this bill.");
        setIrnCancelReasonSelect("");
    }

    const cancelBill = () => {
        const obj1 = {
            hdrSrno: hdrSrno,
            location: spLocationValue,
            type: 'SP',
            irnObj: irnObj,
            irnCancelReason: irnCancelReason,
            irnCancelReasonSelect: irnCancelReasonSelect
        }
        if (irnCancelReason === "") {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please fill reason.");
            return;
        }
        if (!irnCancelDeclaration) {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please check the declaration.");
            return;
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, 'cancelirn', JSON.stringify(obj1)], result => {
            $(".loader").hide();
            setMsgBoxCancelBill(false);
            let resp = JSON.parse(result);
            if (resp.Status == "2") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.Status == "1") {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN cancelled successfully, Cancel Date " + resp.Data.CancelDate);
                } else {
                    alert(JSON.stringify(resp.ErrorDetails));
                }
            }
        });
    }

    const generateIrn = () => {
        const obj1 = {
            coporate: nCorporate,
            individual: nTraveller,
            location: spLocationValue,
            billdate: hdrDateYmd,
            hdrsrno: hdrSrno,
            type: 'SP',
            pForexTotal: pForexTotal,
            pSgst: pSgst,
            pIgst: pIgst,
            pUgst: pUgst,
            pCgst: pCgst,
            pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges,
            pRoundOff: pRoundOff,
            pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
            pTotalAmount: pTotalAmount,
            productList: spProductList,
            ppStateType: spStateType,
            ppStateValue: spStateValue,
            nState: nState.value,
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, "generateirn", JSON.stringify(obj1)], result => {
            let resp = JSON.parse(result);
            $(".loader").hide();
            if (resp.msg != "") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.irn.Status == "0") {
                    alert(JSON.stringify(resp.irn.ErrorDetails));
                } else {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN Generated successfully.");
                }
            }
        });
    }

    const handleMinMaxRate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? " Select ISD." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setShowMinMaxRateModal(true);
            setPIsd(pIsd);
            let a = pIsd.id.split("^");
            setPIsdId(a[1]);//
            setPAgent(null);
            setCommType("F");
            // setCommValue("");
            const obj = {
                isd: a[1],
                location: spLocationValue,
                product: pProduct
            }
            Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp === "") {
                    alert("Select Individual First ");
                    // setMinMaxRate("");
                    $(".loader").hide();
                } else {
                    if (Array.isArray(resp)) {
                        setMinMaxRate(resp);
                    } else if (resp && typeof resp === 'object') {
                        setMinMaxRate([resp]);
                    }
                    $(".loader").hide();
                }
            });
        }
    }
    const handleResetVisa = () => {
        setNVisaType(null);
    }

    const resetCorporate = () => {
        setNCorporate(null);
        setCorporateName("");
        setCorporatePan("");
        setCorporateAddress("");
        setCorporateGstin("");
        setNState({ value: spStateValue, label: spStateName });
        if (nTraveller !== null) {
            var a = nTraveller.id.split("^");
            setPanRelationship({ id: "^1^SELF", label: "1 SELF" });
            setPanRelationshipCode('1')
            setPan(a[4]);
            setPanName(a[3]);
            setNDob(new Date(a[6]));
        }
        if (spProductList.length > 0) {
            const obj = {
                tranType: "SP",
                type: "SALE",
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                ppStateType: spStateType,
                ppStateValue: spStateValue,
                // nState: nState.value, // ye .value pehle wali he ja rahi hai setkarne se
                nState: spStateValue,
                nCorporate: null,
                travellerPan: pan,
                loan: +reqLoanAvailed === 1 ? "Y" : "N",
                purpose: nPurposeId,
                pSelfDeclaration: pSelfDeclaration === "" ? 0 : pSelfDeclaration,

                srno: hdrSrno,
                spLocationValue: spLocationValue,
            }
            calculateGST(spProductList, obj);
        }
    }
    const handlePanRelationshipChange = (value) => {
        setPanRelationship(value);
        if (value.id.split("^")[1] == 1) {
            var a = nTraveller.id.split("^");
            setPan(a[4]);
            setPanName(a[3]);
            setNDob(new Date(a[6]));
        }
        setPanRelationshipCode(value.id.split("^")[1])
    }

    const handleManualNo = (value) => {
        setNManualno(value);
    }

    const handleA2FormView = (id, location, a2Type) => {
        // console.log("Header Serial No. is : ", id);
        const url = `/a2-formSP/${id}/${location}/${a2Type}`;
        const newTab = window.open(url, "_blank");
        if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
            navigate(url);
        }
    }

    const changeDateModal = () => {
        var isOk = true;
        var msg = [], i = 0;
        if (spProductList.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Product List.";
        }
        if (paymentData.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Payment List.";
        }
        if (isOk) {
            setOpenDateChangeModal(true);
            setChangeDateObj(
                {
                    type: "SP",
                    srno: hdrSrno,
                    location: spLocationValue,
                    right: "TRAN_SP",
                    billdate: hdrDate,
                    billdateymd: hdrDateYmd,
                    productList: spProductList,
                    depdate: Common.dateYMD(nDepDate)
                }
            );
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }

    }

    const handleStock = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null || !pDenomination) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? "ISD." : '');
            msg[i++] = (!pDenomination ? "Denomination." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let a = pIsd.id.split("^");
            const obj = {
                isd: a[1],
                date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(spNewDate),
                deno: pDenomination,
                location: spLocationValue,
                // srno: hdrSrno,
                // type: 'SP'
            }
            Common.callApi(Common.apiMasterIBR, [sid, "checkStock", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.status) {
                    // const msg = Common.getStockModelContent(a[1], pDenomination, resp.quantity)
                    setShowStockModal(true);
                    setStockObj({ isd: a[1], quantity: resp.quantity, deno: pDenomination });
                } else {
                    setMsgText(Common.buildMessageFromArray(resp.msg));
                    setMsgBox(true);
                }
            });
        }
    }
    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        // console.log(Common.editDateLimit);
        const vtmactivationunlock = false;


        const obj = {
            srno: hdrSrno,
            type: 'SP',
            pageright: 'TRAN_SP',
            location: spLocationValue,
            spLocation: spLocationValue
        }

        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SP', trannumber: hdrSrno, location: spLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })

    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'SP',
            location: spLocationValue,
            srno: hdrSrno,
            productList: spProductList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listSPdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }
    const handleNextBill = () => {
        const obj = {
            location: spLocationValue,
            type: "SP",
            srno: hdrSrno,
            hdr_tran_source: ""
        };
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        });
    }

    const handlePrevBill = () => {
        const obj = {
            location: spLocationValue,
            type: "SP",
            srno: hdrSrno,
            hdr_tran_source: ""
        };
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No previous bill available.");
                setMsgBox(true);
            }
        });
    }

    const handleAddVtm = () => {
        setMsgBoxYNvtm(false);
        addProduct(true);
    }

    const showPassportForm = () => {
        setShowPassForm(true);
    }
    //jiterndra
    const printHandler = () => {
        $(".loader").show();
        let msg = [];
        msg.push(Common.getMessage("MSG0006"));
        !nTravellerSrno && msg.push("Please select traveller");
        if (msg.length > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                nIndivualSrno: nTravellerSrno,
                type: 'SP',
                location: spLocationValue,
                srno: hdrSrno,
            }
            Common.callApi(Common.apiPrint, [sid, "tcs_eligibility_print", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                var newWindow = window.open();
                newWindow.document.write(resp);
            });
        }
    }

    const exclusiveGSTHandler = () => {
        setOtherChargesInputVisibility(true);
    }

    const gstExclusiveHandler = (v) => {
        setPExclusiveGst(v)
        const val = (v * 100) / 118;
        const roundVal = Math.round(val * 100) / 100;
        otherChargeChange(roundVal + '')
    }

    const handlePdAgentChange = (value) => {
        setPdAgent(value);
        console.log("The Valus is ", value);
        const agent = value.id.split('^');
        setAgentGroup(agent[1]);
        console.log("Group Code is", agent[1]);
        setAgentAccount(agent[2]);
        console.log("Account code is", agent[2]);
    }

    const handleSetIsCommission = (value) => {
        setIsCommission(value);
        setPAgent(null);
        setCommType("F");
        setCommValue("");
        setCommission("");
    }



    const showConfirm = (message) => {
        setMsgTextYN(message);
        setMsgBoxYN(true);

        return new Promise((resolve) => {
            setConfirmResolve(() => resolve);
        });
    };

    const handleYes = () => {
        setMsgBoxYN(false);
        if (confirmResolve) confirmResolve(true);
    };

    const handleNo = () => {
        setMsgBoxYN(false);
        if (confirmResolve) confirmResolve(false);
    };

    const irnPauseHand = async () => {
        let confirmApprove = await showConfirm("Are you sure you want to change status?");

        console.log("confirmApprove", confirmApprove)
        if (!confirmApprove) return;
        $(".loader").show();

        const obj = {
            location: spLocationValue,
            hdrsrno: hdrSrno,
            type: 'SP',
        }

        Common.callApi(Common.apiTranSP, [sid, "irn_pause", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            if (res.status) {
                setScrMode("");
            }
            setMsgText(res.message);
            setMsgBox(true);

        });
    }

    return (
        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ nIndivual: nTraveller, scrIndividual: scrIndividual }} value="TRAN_SP" hideIndividualProfile={hideIndividualProfile} />
                    :
                    <>
                        <LoginHeader />
                        <Menu />
                        <Container fluid>
                            <Row>
                                <Col><h1>Sale to public</h1></Col>
                                <hr />
                            </Row>
                            {
                                scrMode === "" ?
                                    <>
                                        <Row>
                                            <Col className='col-md-6 col-6'>
                                                <Form.Group>
                                                    <Row>
                                                        <Col>
                                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                                        </Col><Col>
                                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Individual" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "C"} onChange={() => setRadioType("C")} type='radio' label="Corporate" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "R"} onChange={() => setRadioType("R")} type='radio' label="Rate Card." />&nbsp;
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={spLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleLocationChange}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {
                                                radioType === "N" ?
                                                    <>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={spNewDate}
                                                                    onChange={(date) => setSPNewDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col style={{ display: "none" }} className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Type</Form.Label>
                                                                <Form.Select value={spSaleType} onChange={e => setSPSaleType(e.target.value)}>
                                                                    <option value="N">Normal</option>
                                                                    <option value="E">EEFBC</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                    : radioType === "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={5} value={spSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSPSrnoFrom)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={5} value={spSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setSPSrnoTo)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                            <>
                                                                {
                                                                    radioType === "I" ?
                                                                        <Col className="col-md-6 col-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Individual Profile<span className="colorThemeRed">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={spIndividual}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={Picklist.fetchIndividualPicklist}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleIndiviualChange}
                                                                                >
                                                                                </AsyncSelect>

                                                                            </Form.Group>
                                                                        </Col>
                                                                        : null
                                                                }
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={spFromDate}
                                                                            onChange={(date) => setSPFromDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={spToDate}
                                                                            onChange={(date) => setSPToDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            : radioType === 'R' ?
                                                                <>
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Product<span className="text-danger">*</span></Form.Label>
                                                                            <Form.Select value={filterProduct} onChange={e => setFilterProduct(e.target.value)}
                                                                                required>
                                                                                <option value="C">CN</option>
                                                                                <option value="R">Card</option>
                                                                                <option value="T">TT</option>
                                                                                <option value="D">DD</option>
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                    </Col>

                                                                </> : null
                                            }
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                {
                                                    +userRight.query === 1 && (radioType !== "N" && radioType !== "R") ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listSPdata()}>List</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    +userRight.add === 1 && radioType === "N" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    +userRight.add === 1 && radioType === "R" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => handleRateCard()}>Get Rate</Button> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Table responsive striped>
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>Sr No</th>
                                                        <th>Type</th>
                                                        <th>Date</th>
                                                        <th>Location</th>
                                                        <th>Individual</th>
                                                        <th>Corporate</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        spList.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span onClick={() => fillViewForm(item.hdr_srno, item.new_date)} className='pointer colorThemeBlue'>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>
                                                                </td>
                                                                <td>{item.hdr_srno}</td>
                                                                <td>{item.hdr_type}</td>
                                                                <td>{item.hdr_date}</td>
                                                                <td>{item.entity_name}</td>
                                                                <td>{item.bd_first_name + ' ' + item.bd_middle_name + ' ' + item.bd_last_name}</td>
                                                                <td>{item.mvli_ledger_name}</td>
                                                                <td>{item.hdr_total_inr}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </>
                                    :
                                    <>
                                        <Row style={{ display: (hdrSrno < 1 || isIrnApplicable === "N") && "none" }}>
                                            <Col>
                                                {
                                                    +isIrnCancelled === 1 ?
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>Bill Deleted</b></p>
                                                            <p className='mx-2'>Delete Date : <b>{irnCancelDate}</b></p>
                                                            <p className='mx-2'>Reason of Deletion: <b>{irnCancelReasonHdr}</b></p>
                                                            <p className='mx-2'>Deletion Remark: <b>{irnCancelRemarkHdr}</b></p>
                                                        </div>
                                                        :
                                                        <>
                                                            {
                                                                +isIrnGenerated === 1 ?
                                                                    <div className='d-flex align-items-baseline'>
                                                                        <p><span style={{ color: "green" }}><FontAwesomeIcon icon={faCircleCheck} /></span> <b>IRN Generated</b></p>
                                                                        {
                                                                            +userRight.delete === 1 &&
                                                                            <Badge className='mx-2 pointer' bg='danger' onClick={cancelBillFinalModal}>Delete Bill</Badge>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className='d-flex align-items-baseline'>
                                                                        <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>IRN Generation Failed</b></p>
                                                                        {
                                                                            (+userRight.add === 1 && scrMode === "Q") &&
                                                                            <Badge className='mx-2 pointer' bg='warning' onClick={generateIrn}>Generate</Badge>
                                                                        }
                                                                    </div>
                                                            }
                                                        </>
                                                }
                                            </Col>
                                        </Row>
                                        {+irnPauseRight?.query === 1 && checkIsirn == 1 && (
                                            <Row>
                                                <Col>
                                                    <div className='d-flex align-items-baseline mb-3'>
                                                        <Badge className='mx-2 pointer' bg='success' onClick={irnPauseHand}>IRN PAUSE</Badge>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                                &nbsp;
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                                        <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>&nbsp;
                                                    </> : null
                                                }
                                                {(scrMode === 'Q' || scrMode === 'E') && <>
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={printHandler}>Tcs Annexure</Button>&nbsp;
                                                </>}
                                                {
                                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                                        {
                                                            +Common.Billprint === 1 &&
                                                            <>
                                                                <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                            </>
                                                        }
                                                        <Button variant="outline-primary" size="sm" className='buttonStyle' onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                        {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                        }
                                                        {+a2FormRight.query === 1 ?
                                                            <>
                                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleA2FormView(hdrSrno, spLocationValue, 'SP')}>A2 Form</Button>&nbsp;
                                                            </> : null
                                                        }
                                                    </> : null
                                                }
                                                {
                                                    scrMode === "Q" &&
                                                    <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.delete === 1) &&
                                                    <>
                                                        &nbsp;
                                                        {+dateChangeRight?.query === 1 &&
                                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.query === 1) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary    " className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.query === 1) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                                    </>
                                                }

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                            </Col>
                                            <Col className="col-md-2 col-4">
                                                <span>Location : <b>{hdrLocation} </b></span>
                                            </Col>
                                            <Col className="col-md-2 col-4">
                                                <span>Date : <b>{hdrDate}</b></span>
                                            </Col>
                                            {/* <Col className="col-md-2 col-4">
                                                <span>Mode : <b>{spSaleType === "N" ? "Normal" : "EEFBC"}</b></span>
                                            </Col> */}
                                            <Col className='ppCharges'>
                                                <span><b>Forex Total (INR): {pForexTotal}</b></span>
                                                &nbsp;&nbsp;&nbsp;
                                                <span><b>Total Amount (INR): {pTotalAmount}</b></span>
                                            </Col>
                                        </Row>
                                        <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                            <Tab eventKey="INFO" title="Info">
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nExecutive}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchExecutivePicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleExecutiveChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Label>Sub Executive</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={nSubExecutive}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={Picklist.fetchSubExecutivePicklist}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleSubExecutiveChange}
                                                            isDisabled={scrMode === "Q"}
                                                        >
                                                        </AsyncSelect>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Mode</Form.Label>
                                                            <Form.Select disabled={scrMode === "Q"} value={nMode} onChange={e => setNMode(e.target.value)}>
                                                                <option value="B">In Branch</option>
                                                                <option value="D">Delivery</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col style={{ display: "none" }} className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Sale Type</Form.Label>
                                                            <Form.Select value={spSaleType} onChange={e => setSPSaleType(e.target.value)} disabled>
                                                                <option value="N">Normal</option>
                                                                <option value="E">EEFBC</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col><h3>Traveller/Applicant Info</h3></Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-12 col-12">
                                                        <Form.Group>
                                                            <Form.Label>Traveller/Applicant Name<span className="colorThemeRed">*</span>
                                                                {
                                                                    scrMode === "Q" ? null :
                                                                        <>
                                                                            <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>&nbsp;&nbsp;
                                                                            <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>&nbsp;&nbsp;
                                                                            {+createIndivisualByPassport?.query === 1 && <span className='tranNewFormText' onClick={() => showPassportForm()}>Add Passport</span>}
                                                                        </>
                                                                }
                                                                {travellerSelected === 1 ?
                                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handlePreTransactionInfo}><Badge bg="secondary">Previous Transaction</Badge></span> : null
                                                                }
                                                                {travellerSelected === 1 ?
                                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleLRSTransactionInfo}><Badge bg="secondary">LRS Transaction</Badge></span> : null
                                                                }
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nTraveller}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchIndividualPicklist(search, "SALE")}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleTravellerChange}
                                                                isDisabled={scrMode === "Q"}
                                                                formatOptionLabel={Picklist.formatOptionLabel}
                                                                components={{ Menu: Picklist.menu }}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Row>
                                                        <Col className='col-md-3 col-3'>
                                                            <Form.Label>Name : <b>{individualName}</b></Form.Label>
                                                        </Col>
                                                        <Col className="col-md-2 col-3">
                                                            <span>Pan : <b>{individualPan} </b></span>
                                                        </Col>
                                                        <Col className="col-md-7 col-6">
                                                            <span>Address : <b>{individualAddress}</b></span>
                                                        </Col>
                                                    </Row>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Pan Relationship<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={panRelationship}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchPanRelationShipPicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handlePanRelationshipChange}
                                                                isDisabled={scrMode === "Q" || nCorporate != null}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>PAN</Form.Label>
                                                            <Form.Control type="text" placeholder="PAN" maxLength={10}
                                                                value={pan}
                                                                onChange={(e) => setPan(e.target.value)}
                                                                onBlur={(e) => Common.validatePan(e.target.value, setPan)}
                                                                disabled={scrMode === 'Q' || nCorporate != null || +panRelationShipCode === 1}
                                                                autoComplete="off" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Name on PAN <span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control disabled={scrMode === "Q" || nCorporate != null} placeholder='NAME' type='text' maxLength={250} value={panName}
                                                                onChange={e => Common.validateNameonPan(e.target.value, setPanName)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>DOB/Inception Date<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={nDob}
                                                                onChange={(date) => setNDob(date)}
                                                                maxDate={new Date()}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                disabled={scrMode === "Q" || +panRelationShipCode === 1 || nCorporate != null}
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Purpose<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nPurpose}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchPurposePicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handlePurposeChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {nPurposeId === '20' ? <>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Encashment Number</Form.Label>
                                                                <Form.Control type="text" maxLength={255} placeholder='Encashment Number' disabled={scrMode === "Q"} value={nEncashmentNumber} onChange={e => Common.validateAlpNumSplValue(e.target.value, setNEncashmentNumber)} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Group>
                                                                <Form.Label>Encashment Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={nEncashmentDate}
                                                                    onChange={(date) => setNEncashmentDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    disabled={scrMode === "Q"}
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Encashed from </Form.Label>
                                                                <Form.Control type="text" maxLength={255} placeholder='Encashment From' disabled={scrMode === "Q"} value={nEncashmentFrom} onChange={e => Common.validateAlpNumSplValue(e.target.value, setNEncashmentFrom)} />
                                                            </Form.Group>
                                                        </Col>
                                                    </> : null}
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Residential Status<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Select disabled={scrMode === "Q"} value={nResident} onChange={e => setNResident(e.target.value)}>
                                                                {
                                                                    residentOptions.map((item, index) => (
                                                                        <option value={item.mrs_srno} key={index}>{item.mrs_resident}</option>
                                                                    ))
                                                                }
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Place of Supply</Form.Label>
                                                            <Select isDisabled options={stateOptions} value={nState} onChange={v => setNState(v)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Manual Number</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nManualno}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchManualTypePicklist(search, spLocationValue, 'SP')} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleManualNo}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-12 col-12">
                                                        <Form.Group>
                                                            <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                                <span>Corporate</span>{nPurposeId == "1" && <span className="colorThemeRed">*</span>}
                                                                <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => resetCorporate()}><Badge bg="secondary">Reset</Badge></span>
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nCorporate}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE,DIVISION', spLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleCorporateChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Row>
                                                        <Col className='col-md-3 col-3'>
                                                            <Form.Label>Name : <b>{corporateName}</b></Form.Label>
                                                        </Col>
                                                        <Col className="col-md-3 col-3">
                                                            <span>Pan : <b>{corporatePan} </b></span>
                                                        </Col>
                                                        <Col className="col-md-2 col-2">
                                                            <span>Gstin : <b>{corporateGstin}</b></span>
                                                        </Col>
                                                        <Col>
                                                            <span>Address : <b>{corporateAddress}</b></span>
                                                        </Col>
                                                    </Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Traveller/Employee Code</Form.Label>
                                                            <Form.Control disabled={scrMode === "Q"} maxLength={20} value={nTravellerCode} onChange={e => setNTravellerCode(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Employee Type</Form.Label>
                                                            <Form.Select disabled={scrMode === "Q"} value={empType} onChange={e => setEmpType(e.target.value)}>
                                                                <option value="">Select</option>
                                                                <option value="E">Employee</option>
                                                                <option value="P">Proprieter</option>

                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Source of Fund<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={sourceOfFund}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchSourceOfFundPicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleSourceFundChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {sourceOfFundValue === 'OTHER' ?
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Enter Source Of Income<span className="colorThemeRed">*</span></Form.Label>
                                                                <Form.Control disabled={scrMode === "Q"} placeholder='Source Of Income' type='text' maxLength={50} value={sourceOfFundOther} onChange={e => Common.validateAlpNumValue(e.target.value, setSourceOfFundOther)} />
                                                            </Form.Group>
                                                        </Col> : null
                                                    }

                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col><h3>Visit Info</h3></Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Country to Visit<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nCountry}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchCountryPicklist(search)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleCountryChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Ticket Class</Form.Label>
                                                            <Form.Select disabled={scrMode === "Q"} value={nTicketClass} onChange={e => setNTicketClass(e.target.value)}>
                                                                <option value="">Select</option>
                                                                <option value="FC">First Class</option>
                                                                <option value="BC">Business Class</option>
                                                                <option value="EC">Economy Class</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Flight No<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control disabled={scrMode === "Q"} placeholder='Flight No' type='text' maxLength={20} value={nFlightNo} onChange={e => Common.validateAlpNumValue(e.target.value, setNFlightNo)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Ticket No<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control disabled={scrMode === "Q"} placeholder='Ticket No' type='text' maxLength={20} value={nTicketNo} onChange={e => Common.validateAlpNumValue(e.target.value, setNTicketNo)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Departure Date<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={nDepDate}
                                                                onChange={(date) => setNDepDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                disabled={scrMode === "Q"}
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Duration of stay abroad<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control disabled={scrMode === "Q"} placeholder='Duration' type='text' maxLength={5} value={nDuration} onChange={e => Common.validateDecValue(e.target.value, setNDuration)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Visa Type<span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleResetVisa}><Badge bg="secondary">Reset</Badge></span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nVisaType}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchVisaTypePicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleVisaTypeChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Remark 1</Form.Label>
                                                            <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Remark 2</Form.Label>
                                                            <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2}
                                                                onChange={e => setNRemark2(e.target.value)}
                                                            // onChange={e => Common.validateNameOnPan(e.target.value, setNRemark2)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        +nPurposeIsLoan === 1 && sourceOfFundValue === "VALUE" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan</Form.Label>
                                                                    <Form.Select disabled value={reqLoanAvailed} onChange={e => setReqLoanAvailed(e.target.value)}>
                                                                        <option value="0">No</option>
                                                                        <option value="1">Yes</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            :
                                                            null
                                                    }
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                {
                                                    +reqLoanAvailed === 1 &&
                                                    <>
                                                        <Row>
                                                            <Col><h3>Loan Related Details</h3></Col>
                                                        </Row>

                                                        <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Institute Name</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                                                        value={reqLoanInstName}
                                                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqLoanInstName)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Account No</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                                                        value={reqLoanAccountNo}
                                                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqLoanAccountNo)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Disb. Amount</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                                                        value={reqLoanDisbAmt}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqLoanDisbAmt)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Disb. Date</Form.Label>
                                                                    <DatePicker className="form-control"
                                                                        selected={reqLoanDisbDate}
                                                                        onChange={(date) => setReqLoanDisbDate(date)}
                                                                        dateFormat="dd/MM/yyyy"
                                                                        showYearDropdown
                                                                        showMonthDropdown
                                                                        useShortMonthInDropdown
                                                                        dropdownMode="select"
                                                                        peekNextMonth
                                                                        customInput={
                                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                        }
                                                                        disabled={scrMode === "Q"}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Disb Reference No</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                                                        value={reqLoanDisbRefNo}
                                                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqLoanDisbRefNo)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Applicant</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Applicant" maxLength={50} autoComplete="off"
                                                                        value={reqLoanApplicant}
                                                                        onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanApplicant)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Applicant Passport</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Applicant Passport" maxLength={50} autoComplete="off"
                                                                        value={reqLoanApplicantPassport}
                                                                        onChange={(e) => setReqLoanApplicantPassport(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Applicant Pan</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Applicant Pan" maxLength={10} autoComplete="off"
                                                                        value={reqLoanApplicantPan}
                                                                        onChange={(e) => setReqLoanApplicantPan(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Co Applicant</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Co Applicant" maxLength={50} autoComplete="off"
                                                                        value={reqLoanCoApplicant}
                                                                        onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanCoApplicant)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Co App Passport</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Co App Passport" maxLength={50} autoComplete="off"
                                                                        value={reqLoanCoApplicantPassport}
                                                                        onChange={(e) => setReqLoanCoApplicantPassport(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Loan Co App Pan</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} type="text" placeholder="Loan Co App Pan" maxLength={50} autoComplete="off"
                                                                        value={reqLoanCoApplicantPan}
                                                                        onChange={(e) => setReqLoanCoApplicantPan(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("DETAILS")}>Details-&gt;</Button>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="DETAILS" title="Details">
                                                <Row>
                                                    <Col>
                                                        <h4>Product Info</h4>
                                                    </Col>
                                                </Row>
                                                {
                                                    scrMode === "Q" ? null
                                                        :
                                                        <>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Product<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Select value={pProduct} onChange={e => handleProductChange(e.target.value)} ref={productRef}>
                                                                            <option value="CN">CN</option>
                                                                            <option value="VTM">VTM</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pProduct === "VTM" &&
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                                                            <Form.Select value={pSaleReload} onChange={e => handleSaleTypeChange(e.target.value)}>
                                                                                <option value="S">Sale</option>
                                                                                <option value="R">Reload</option>
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                    </Col>
                                                                }
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>ISD<span className="colorThemeRed">*</span>
                                                                            &nbsp;&nbsp;
                                                                            {(pIsd !== null && pProduct === "VTM") && <Badge bg='success' size='sm'>DSR: ({dsrRate})</Badge>}
                                                                        </Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pIsd}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, pProduct)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleChangeIsd}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pProduct === "VTM" ?
                                                                        <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>Issuer<span className="colorThemeRed">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={pIssuer}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', spLocationValue)} // location = 1 , 2
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleIssuerChange}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        : null
                                                                }
                                                            </Row>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>{pProduct === "VTM" ? "Value" : "Denomination"}
                                                                            <span className="colorThemeRed">*</span>
                                                                        </Form.Label>
                                                                        <Form.Control type='text' value={pDenomination} maxLength={9}
                                                                            onChange={e => handleDenoChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6' style={{ display: pProduct === "VTM" && "none" }}>
                                                                    <Form.Group>
                                                                        <Form.Label>Quantity<span className="colorThemeRed">*</span></Form.Label>
                                                                        {pProduct === "CN" && <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleStock}>
                                                                            <Badge className='handCursor' bg="secondary">Check Stock</Badge></span>}
                                                                        <Form.Control type='text' placeholder='Quantity' value={pQuantity} maxLength={9}
                                                                            onChange={e => handleQuantityChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>

                                                                        <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleMinMaxRate}><Badge bg="secondary">See Min/Max Rate</Badge></span>
                                                                        <Form.Control type='text' placeholder='Rate' value={pRate} maxLength={Common.rateMaxLength}
                                                                            onChange={e => handleRateChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            {
                                                                pProduct === "VTM" ?
                                                                    <Row>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Prefix</Form.Label>
                                                                                <Form.Control disabled placeholder='Prefix' type='text' maxLength={5} value={prPrefix} onChange={e => Common.validateAlpNumValue(e.target.value, setPrPrefix)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                                {
                                                                                    pSaleReload === "S" ?
                                                                                        <AsyncSelect
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={prFrom}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={(search) => Picklist.fetchVtcInlist(search, { isd: pIsdId, location: spLocationValue, group: pIssuerGroup, account: pIssuerAccount, product: "VTM", type: "VTMIN", hdrDateYMD: (hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd) })}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleFromChange}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                        :
                                                                                        <AsyncSelect
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={prFrom}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={(search) => Picklist.fetchVtcBilllist(search, { isd: pIsdId, location: spLocationValue, individual: nTravellerSrno, group: pIssuerGroup, account: pIssuerAccount, product: "VTM", type: "SP", hdrDateYMD: (hdrSrno < 1 ? Common.dateYMD(spNewDate) : hdrDateYmd) })}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleFromChange}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                }
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control disabled placeholder='To' type='text' maxLength={6} value={prTo} onChange={e => Common.validateNumValue(e.target.value, setPrTo)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Card No<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control disabled={pSaleReload === "R"} placeholder='Card No' maxLength={20} type='text' value={pVtmCardNo} onChange={e => Common.validateNumValue(e.target.value, setPVtmCardNo)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    : null
                                                            }
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission</Form.Label>
                                                                        <Form.Select value={isCommission} onChange={e => handleSetIsCommission(e.target.value)}>
                                                                            <option value="0">No</option>
                                                                            <option value="1">Yes</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    +isCommission === 1 ?
                                                                        <>
                                                                            <Col className='col-md-12 col-12'>
                                                                                <Form.Group>
                                                                                    <Form.Label>Agent<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={pAgent}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', spLocationValue)} // location = 1 , 2
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        onChange={handleAgentChange}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Row>
                                                                                <Col className='col-md-3 col-3'>
                                                                                    <Form.Label>Name : <b>{agentName}</b></Form.Label>
                                                                                </Col>
                                                                                <Col className="col-md-2 col-2">
                                                                                    <span>Pan : <b>{agentPan} </b></span>
                                                                                </Col>
                                                                                <Col>
                                                                                    <span>Address : <b>{agentAddress}</b></span>
                                                                                </Col>
                                                                            </Row>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Select value={commType} onChange={e => commissionTypeChange(e.target.value)}

                                                                                        disabled={true}
                                                                                    >
                                                                                        <option value="F">Flat</option>
                                                                                        <option value="">Select</option>
                                                                                        <option value="P">Paisa</option>
                                                                                        <option value="R">Percentage</option>
                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col>
                                                                                <Form.Group>
                                                                                    <Form.Label>Commission<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control type='text' maxLength={8} value={commission} onChange={e => handleCommissionCalc(e.target.value)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col>
                                                                                <Form.Group>
                                                                                    <Form.Label>Commission Value</Form.Label>
                                                                                    <Form.Control disabled value={commValue} onChange={e => Common.validateDecValue(e.target.value, setCommValue)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </>
                                                                        : null
                                                                }
                                                            </Row>
                                                            <Row>&nbsp;</Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct(false)}>Add</Button>
                                                                    &nbsp;
                                                                    <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Check type='checkbox' checked={showCommissionDetail} onChange={e => setShowCommissionDetail(e.target.checked)} label='Commission Details' />
                                                        {/* <Badge className='handCursor' bg="primary" onClick={handleShowCommissionDetail}>View Commission Details</Badge> */}
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Table responsive bordered striped>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Product</th>
                                                                <th>Isd Code</th>
                                                                <th>Isd Name</th>
                                                                <th>Denomination</th>
                                                                <th>Quantity</th>
                                                                <th>Rate</th>
                                                                <th>Amount</th>
                                                                <th>USD Rate</th>
                                                                <th>USD Amount</th>
                                                                <th>Prefix</th>
                                                                <th>From</th>
                                                                <th>To</th>
                                                                <th>Card No</th>
                                                                {
                                                                    showCommissionDetail &&
                                                                    <>
                                                                        <th>Agent</th>
                                                                        <th>Commission Type</th>
                                                                        <th>Commission</th>
                                                                        <th>Commission Value</th>
                                                                    </>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                spProductList.map((item, index) => (
                                                                    <>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    scrMode === "Q" || item.delny === "N" ? null :
                                                                                        <span title={"delete"} onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </span>
                                                                                } &nbsp;
                                                                                {
                                                                                    item.delny === "N" ?
                                                                                        <span title={`Approved By: ${item.activated_by}\nApproved On: ${item.activation_date}`} className="handCursor colorThemeBlue">
                                                                                            <FontAwesomeIcon icon={faCircleInfo} />
                                                                                        </span> : null
                                                                                }
                                                                            </td>
                                                                            <td>{item.prd_product}</td>
                                                                            <td>{item.prd_isd}</td>
                                                                            <td>{item.isd_name}</td>
                                                                            <td>{item.prd_deno}</td>
                                                                            <td>{item.prd_qty}</td>
                                                                            <td>{item.prd_rate}</td>
                                                                            <td>{item.prd_amount}</td>
                                                                            <td>{item.prd_usd_rate}</td>
                                                                            <td>{item.prd_usd_amount}</td>
                                                                            <td>{item.prd_prefix}</td>
                                                                            <td>{item.prd_from}</td>
                                                                            <td>{item.prd_to}</td>
                                                                            <td>{item.prd_card_no}</td>
                                                                            {
                                                                                showCommissionDetail &&
                                                                                <>
                                                                                    {
                                                                                        item.prd_agent_group == "0" ?
                                                                                            <td></td> :
                                                                                            <td>{item.prd_agent_group + " " + item.prd_agent_ledger + " " + item.prd_agent_name}</td>
                                                                                    }
                                                                                    <td>{item.prd_commission_type === "P" ? "Paisa"
                                                                                        : item.prd_commission_type === "R" ? "Percentage"
                                                                                            : item.prd_commission_type === "F" ? "Flat" : ""}</td>
                                                                                    <td>{item.prd_commission * 1 > 0 ? item.prd_commission : ""}</td>
                                                                                    <td>{item.prd_commission_value * 1 > 0 ? item.prd_commission_value : ""}</td>
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                        {
                                                                            item.prd_product === "VTM" ? <>
                                                                                <tr key={index + '1'} >
                                                                                    <td colspan="14" >


                                                                                        {item.prd_sale_reload === "R" ? "Reload" : "Sale"}&nbsp;Br Sett : {item.prd_stb_date_dmy}&nbsp;{item.prd_stb_type}-{item.prd_stb_srno}&nbsp;

                                                                                        Exported On : {item.prd_vtm_export_date_dmy}&nbsp;Activate on : {item.prd_vtm_activation_date_dmy}

                                                                                        {
                                                                                            1 * item.prd_stc_srno > 0 ? <>
                                                                                                &nbsp;Corp Sett : {item.prd_stc_date_dmy}&nbsp;{item.prd_stc_type}-{item.prd_stc_srno}&nbsp;
                                                                                            </> : null
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            </> : null
                                                                        }

                                                                    </>


                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="PAYMENT" title="Payment">
                                                <Row>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>SGST: {pSgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>IGST: {pIgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>CGST : {pCgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>UGST : {pUgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>TCS : {pTcs}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    {/* <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                        <span>OtherCharges: &nbsp;</span>
                                                        <span>
                                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                                maxLength={10}
                                                                value={pOtherCharges}
                                                                onChange={e => otherChargeChange(e.target.value)}
                                                                disabled={disableOtherCharge || scrMode === "Q"}
                                                            />
                                                        </span>
                                                    </Col> */}
                                                    <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                        <Form.Group>
                                                            <Form.Label>OtherCharges: &nbsp;
                                                                {
                                                                    scrMode !== "Q" &&
                                                                    <Badge className='mx-2 pointer' bg='danger' onClick={() => exclusiveGSTHandler()}>Inclusive GST</Badge>
                                                                }
                                                            </Form.Label>
                                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                                maxLength={10}
                                                                value={pOtherCharges}
                                                                onChange={e => otherChargeChange(e.target.value)}
                                                                disabled={disableOtherCharge || scrMode === "Q" || otherChargesInputVisibility}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    &nbsp;
                                                    <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                        <Form.Group>
                                                            <Form.Label>Other Forex Self Declaration: &nbsp;</Form.Label>

                                                            <Form.Control size='sm' placeholder='Self Declaration' type='text'
                                                                maxLength={12}
                                                                value={pSelfDeclaration}
                                                                onChange={e => selfDeclarationChange(e.target.value)}
                                                                disabled={disableOtherCharge || scrMode === "Q"}
                                                            />

                                                        </Form.Group>
                                                    </Col>
                                                    {otherChargesInputVisibility && <Col className="col-md-3 col-6" >
                                                        <Form.Group>
                                                            <Form.Label>Inclusive GST: &nbsp;</Form.Label>
                                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                                maxLength={10}
                                                                value={pExclusiveGst}
                                                                onChange={e => gstExclusiveHandler(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Commission on Other Charges</Form.Label>
                                                            <Form.Select value={pdCommisionOnOtherCharges} onChange={e => setPdCommisionOnOtherCharges(e.target.value)}
                                                                disabled={scrMode === "Q"}
                                                            >
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {
                                                    +pdCommisionOnOtherCharges === 1 &&
                                                    <>
                                                        <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Agent<span className='colorThemeRed'>*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={pdAgent}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', spLocationValue)}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handlePdAgentChange}
                                                                        isDisabled={scrMode === "Q"}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Commission on Other Charges<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Commission' value={pdCommission} onChange={e => Common.validateDecValue(e.target.value, setPdCommission)}
                                                                        disabled={scrMode === "Q"}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                }
                                                <hr />
                                                <Row>
                                                    <Col><h3>Payment Details</h3></Col>
                                                </Row>
                                                {
                                                    scrMode === "Q" ? null
                                                        :
                                                        <>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Payment Type</Form.Label>
                                                                        <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                                        // onBlur={e => handlePaymentType(e.target.value)}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            <option value="CH">Cash</option>
                                                                            <option value="BN">Bank</option>
                                                                            <option value="CQ">Cheque</option>
                                                                            <option value="RC">Receivable</option>
                                                                            {/* <option value="PB">Payables</option> */}
                                                                            {/* <option value="AP">Advance Paid</option>
                                                                            <option value="AR">Advance Recieved</option> */}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pdAccount}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, spLocationValue)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleAccountValue}
                                                                            isDisabled={disablePaymentAccount}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pdPaymentType !== "" ?
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Amount<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                            </Form.Group>
                                                                        </Col> : null
                                                                }
                                                            </Row>
                                                            {
                                                                pdPaymentType === "BN" ?
                                                                    <Row>
                                                                        <Col className="col-md-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    : pdPaymentType === "CQ" ?
                                                                        <Row>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control placeholder='Cheque No' type='text' maxLength={10} value={pdChequeNum} onChange={e => Common.validateAlpNumValue(e.target.value, setPdChequeNum)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Bank Name<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control placeholder='Bank Name' type='text' maxLength={50} value={chequeBankName} onChange={e => Common.validateAlpNumValue(e.target.value, setChequeBankName)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Cheque Date<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <DatePicker className="form-control"
                                                                                        selected={chequeDate}
                                                                                        onChange={(date) => setChequeDate(date)}
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        showYearDropdown
                                                                                        showMonthDropdown
                                                                                        useShortMonthInDropdown
                                                                                        dropdownMode="select"
                                                                                        peekNextMonth
                                                                                        customInput={
                                                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                                        }
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        : pdPaymentType === "RC" ?
                                                                            <Row>
                                                                                <Col>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Remark<span className="colorThemeRed">*</span></Form.Label>
                                                                                        <Form.Control type="text" maxLength={255} placeholder='Remark' disabled={scrMode === "Q"} value={pdRemark} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdRemark)} />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            : null
                                                            }
                                                            <Row>&nbsp;</Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Type</th>
                                                                <th>Group</th>
                                                                <th>Account</th>
                                                                <th>Name</th>
                                                                <th>Amount</th>
                                                                <th>Cheque/Refernece No/Remark</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                paymentData.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {
                                                                                scrMode !== "Q" ?
                                                                                    <span className='colorThemeBlue pointer' onClick={() => deletePayment(item)}>
                                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                                    </span> : null
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item.tp_payment_type === "BN"
                                                                                    ? "Bank" : item.tp_payment_type === "CQ"
                                                                                        ? "Cheque" : item.tp_payment_type === "CH"
                                                                                            ? "Cash" : item.tp_payment_type === "RC"
                                                                                                ? "Receivable" : item.tp_payment_type === "PB"
                                                                                                    ? "Payables" : item.tp_payment_type === "AP"
                                                                                                        ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                            ? "Advance Received" : ""
                                                                            }
                                                                        </td>
                                                                        <td>{item.tp_group}</td>
                                                                        <td>{item.tp_account}</td>
                                                                        <td>{item.mvli_ledger_name}</td>
                                                                        <td>{item.tp_amount}</td>
                                                                        <td>{item.tp_payment_type === "RC" ? item.tp_remark : item.tp_cheque}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Row>
                                            </Tab>
                                        </Tabs>
                                        <hr />
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                                &nbsp;
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                                        <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>
                                                    </> : null
                                                }
                                                {(scrMode === 'Q' || scrMode === 'E') && <>
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={printHandler}>Tcs Annexure</Button>&nbsp;
                                                </>
                                                }
                                                {
                                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                                        {
                                                            +Common.Billprint === 1 &&
                                                            <>
                                                                <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                            </>
                                                        }
                                                        <Button variant="outline-primary" size="sm" className='buttonStyle' onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                        {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                        }
                                                        {+a2FormRight.query === 1 ?
                                                            <>
                                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleA2FormView(hdrSrno, spLocationValue, 'SP')}>A2 Form</Button>&nbsp;
                                                            </> : null
                                                        }
                                                    </> : null
                                                }
                                                {
                                                    scrMode === "Q" &&
                                                    <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.delete === 1) &&
                                                    <>
                                                        &nbsp;
                                                        {+dateChangeRight?.query === 1 &&
                                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </>
                            }
                        </Container>
                    </>
            }
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Modal show={showPreviousTransactionModal} size='xl' onHide={() => setShowPreviousTransactionModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>Previous Transaction</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th> Branch</th>
                                    <th>Type</th>
                                    <th>Certificate</th>
                                    <th>Date</th>
                                    <th>USD</th>
                                    <th>Departure</th>
                                    <th>Cash</th>
                                    <th>Bank</th>
                                    <th>Receivable</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    preTransaction.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.entity_name}</td>
                                            <td>{item.tp_type}</td>
                                            <td>{item.hdr_srno}</td>
                                            <td>{item.hdr_date}</td>
                                            <td>{item.prd_usd_amount}</td>
                                            <td>{item.hdr_departure_date}</td>
                                            <td>{item.ch}</td>
                                            <td>{item.bn + item.cq}</td>
                                            <td>{item.rc}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showLRSTransactionModal} size='xl' onHide={() => setShowLRSTransactionModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>Previous Transaction</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th> Branch</th>
                                    <th>Type</th>
                                    <th>Certificate</th>
                                    <th>Date</th>
                                    <th>ISD</th>
                                    <th>USD Equivalent</th>
                                    <th>Value</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    lrsTransaction.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.entity_name}</td>
                                            <td>{item.tp_type}</td>
                                            <td>{item.hdr_srno}</td>
                                            <td>{item.hdr_date}</td>
                                            <td>{item.prd_isd}</td>
                                            <td>{item.prd_usd_amount}</td>
                                            <td>{item.prd_rate}</td>
                                            <td>{item.tp_amount}</td>

                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showMinMaxRateModal} size='xl' onHide={() => setShowMinMaxRateModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>MIN/MAX RATE CARD</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th>ISD</th>
                                    <th> MINIMUM</th>
                                    <th>RATE</th>
                                    <th>MAXIMUM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {minMaxRate.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.isd}</td>
                                        <td>{item.minsalerate}</td>
                                        <td>{item.salerate}</td>
                                        <td>{item.maxsalerate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <span className="corner-span">{counter}</span>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />

            {/* <Tran_commission_view show={showCommissionDetail} onHide={() => setShowCommissionDetail(false)} productList={spProductList} /> */}

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <DialogYesNo isOpen={isMsgBoxCreditLimit} onYes={(e) => createCreditLimit()} onNo={(e) => setMsgBoxCreditLimit(false)}>
                {msgTextCreditLimit}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} billDetails={{ type: "SP", isirn: isIrnGenerated }} onNo={(e) => setMsgBoxYNBillDelete(false)} >
                {msgTextYNBillDelete}
            </CancelDialog>
            <DialogYesNo isOpen={isMsgBoxYNvtm} onYes={(e) => handleAddVtm()} onNo={(e) => setMsgBoxYNvtm(false)}>
                {msgTextYNvtm}
            </DialogYesNo>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={handleYes} onNo={handleNo}            >
                {msgTextYN}
            </DialogYesNo>

            <Dialog_IRN
                isOpen={isMsgBoxCancelBill}
                onYes={(e) => cancelBill()}
                onNo={(e) => setMsgBoxCancelBill(false)}
                text={msgTextCancelBill}
                checkLabel={irnCancelLabel}
                irnCancelDeclaration={irnCancelDeclaration}
                setIrnCancelDeclaration={setIrnCancelDeclaration}
                irnCancelReason={irnCancelReason}
                setIrnCancelReason={setIrnCancelReason}
                irnCancelReasonSelect={irnCancelReasonSelect}
                setIrnCancelReasonSelect={setIrnCancelReasonSelect}
            />
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <>
                            <h4>{riskModalBoxText}</h4>
                            <Form.Group>
                                <Form.Label>Action Taken<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Reason" maxLength={499}
                                    value={acRemark}
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setAcRemark)}
                                    autoComplete="off"
                                    required />
                            </Form.Group>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => saveData(true)}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Tran_date_change_modal openDateChangeModal={openDateChangeModal} setOpenDateChangeModal={setOpenDateChangeModal} changeDateObj={changeDateObj} setMsgBox={setMsgBox} setMsgText={setMsgText} />
            <Tran_stock_modal showStockModal={showStockModal} setShowStockModal={setShowStockModal} stockObj={stockObj} />
            <Tran_passport_form show={showPassForm} onHide={() => setShowPassForm(false)} proceedHandler={hideIndividualProfile} type="SP" />

        </>
    )
}

export default Tran_sp
